/**
 * Do not edit directly
 * Generated on Fri, 01 Jul 2022 19:20:40 GMT
 */

module.exports = {
  'theme-colors': {
    outerverse: {
      primary: {
        yellow: {
          value: '#fdd100',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#fdd100',
            type: 'color'
          },
          name: 'ThemeColorsOuterversePrimaryYellow',
          attributes: {
            category: 'theme-colors',
            type: 'outerverse',
            item: 'primary',
            subitem: 'yellow'
          },
          path: ['theme-colors', 'outerverse', 'primary', 'yellow']
        },
        red: {
          value: '#EA2127',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#EA2127',
            type: 'color'
          },
          name: 'ThemeColorsOuterversePrimaryRed',
          attributes: {
            category: 'theme-colors',
            type: 'outerverse',
            item: 'primary',
            subitem: 'red'
          },
          path: ['theme-colors', 'outerverse', 'primary', 'red']
        }
      },
      secondary: {
        'green-dark': {
          value: '#545945',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#545945',
            type: 'color'
          },
          name: 'ThemeColorsOuterverseSecondaryGreenDark',
          attributes: {
            category: 'theme-colors',
            type: 'outerverse',
            item: 'secondary',
            subitem: 'green-dark'
          },
          path: ['theme-colors', 'outerverse', 'secondary', 'green-dark']
        },
        green: {
          value: '#71836B',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#71836B',
            type: 'color'
          },
          name: 'ThemeColorsOuterverseSecondaryGreen',
          attributes: {
            category: 'theme-colors',
            type: 'outerverse',
            item: 'secondary',
            subitem: 'green'
          },
          path: ['theme-colors', 'outerverse', 'secondary', 'green']
        },
        'green-light': {
          value: '#91B97C',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#91B97C',
            type: 'color'
          },
          name: 'ThemeColorsOuterverseSecondaryGreenLight',
          attributes: {
            category: 'theme-colors',
            type: 'outerverse',
            item: 'secondary',
            subitem: 'green-light'
          },
          path: ['theme-colors', 'outerverse', 'secondary', 'green-light']
        }
      },
      tertiary: {
        black: {
          value: '#000000',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#000000',
            type: 'color'
          },
          name: 'ThemeColorsOuterverseTertiaryBlack',
          attributes: {
            category: 'theme-colors',
            type: 'outerverse',
            item: 'tertiary',
            subitem: 'black'
          },
          path: ['theme-colors', 'outerverse', 'tertiary', 'black']
        },
        'black-soft': {
          value: '#363535',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#363535',
            type: 'color'
          },
          name: 'ThemeColorsOuterverseTertiaryBlackSoft',
          attributes: {
            category: 'theme-colors',
            type: 'outerverse',
            item: 'tertiary',
            subitem: 'black-soft'
          },
          path: ['theme-colors', 'outerverse', 'tertiary', 'black-soft']
        },
        'grey-dark': {
          value: '#646464',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#646464',
            type: 'color'
          },
          name: 'ThemeColorsOuterverseTertiaryGreyDark',
          attributes: {
            category: 'theme-colors',
            type: 'outerverse',
            item: 'tertiary',
            subitem: 'grey-dark'
          },
          path: ['theme-colors', 'outerverse', 'tertiary', 'grey-dark']
        },
        grey: {
          value: '#AEAEAE',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#AEAEAE',
            type: 'color'
          },
          name: 'ThemeColorsOuterverseTertiaryGrey',
          attributes: {
            category: 'theme-colors',
            type: 'outerverse',
            item: 'tertiary',
            subitem: 'grey'
          },
          path: ['theme-colors', 'outerverse', 'tertiary', 'grey']
        },
        'grey-light': {
          value: '#DEDDDD',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#DEDDDD',
            type: 'color'
          },
          name: 'ThemeColorsOuterverseTertiaryGreyLight',
          attributes: {
            category: 'theme-colors',
            type: 'outerverse',
            item: 'tertiary',
            subitem: 'grey-light'
          },
          path: ['theme-colors', 'outerverse', 'tertiary', 'grey-light']
        },
        'eggshell-medium': {
          value: '#F4F0EA',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#F4F0EA',
            type: 'color'
          },
          name: 'ThemeColorsOuterverseTertiaryEggshellMedium',
          attributes: {
            category: 'theme-colors',
            type: 'outerverse',
            item: 'tertiary',
            subitem: 'eggshell-medium'
          },
          path: ['theme-colors', 'outerverse', 'tertiary', 'eggshell-medium']
        },
        eggshell: {
          value: '#F9F6F2',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#F9F6F2',
            type: 'color'
          },
          name: 'ThemeColorsOuterverseTertiaryEggshell',
          attributes: {
            category: 'theme-colors',
            type: 'outerverse',
            item: 'tertiary',
            subitem: 'eggshell'
          },
          path: ['theme-colors', 'outerverse', 'tertiary', 'eggshell']
        },
        white: {
          value: '#FFFFFF',
          type: 'color',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '#FFFFFF',
            type: 'color'
          },
          name: 'ThemeColorsOuterverseTertiaryWhite',
          attributes: {
            category: 'theme-colors',
            type: 'outerverse',
            item: 'tertiary',
            subitem: 'white'
          },
          path: ['theme-colors', 'outerverse', 'tertiary', 'white']
        }
      },
      variables: {
        'default-bgs': {
          'block-dark': {
            value: {
              value: '#000000',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#000000',
                type: 'color'
              },
              name: 'ColorsPrimaryBlack',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black'
              },
              path: ['colors', 'primary', 'black']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesDefaultBgsBlockDark',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'default-bgs',
              state: 'block-dark'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'default-bgs',
              'block-dark'
            ]
          },
          'block-light': {
            value: {
              value: '#fdd100',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#fdd100',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesDefaultBgsBlockLight',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'default-bgs',
              state: 'block-light'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'default-bgs',
              'block-light'
            ]
          }
        },
        'default-colors': {
          heading: {
            value: {
              value: '#fdd100',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#fdd100',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesDefaultColorsHeading',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'default-colors',
              state: 'heading'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'default-colors',
              'heading'
            ]
          },
          'paragraph-copy': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesDefaultColorsParagraphCopy',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'default-colors',
              state: 'paragraph-copy'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'default-colors',
              'paragraph-copy'
            ]
          },
          alert: {
            value: {
              value: '#EA2127',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#EA2127',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryRed',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'red'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'red']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.red}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesDefaultColorsAlert',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'default-colors',
              state: 'alert'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'default-colors',
              'alert'
            ]
          },
          success: {
            value: {
              value: '#71836B',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#71836B',
                type: 'color'
              },
              name: 'ThemeColorsOuterverseSecondaryGreen',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'secondary',
                subitem: 'green'
              },
              path: ['theme-colors', 'outerverse', 'secondary', 'green']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.secondary.green}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesDefaultColorsSuccess',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'default-colors',
              state: 'success'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'default-colors',
              'success'
            ]
          },
          'accent-border': {
            value: {
              value: '#fdd100',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#fdd100',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesDefaultColorsAccentBorder',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'default-colors',
              state: 'accent-border'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'default-colors',
              'accent-border'
            ]
          },
          link: {
            value: {
              value: '#EA2127',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#EA2127',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryRed',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'red'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'red']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.red}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesDefaultColorsLink',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'default-colors',
              state: 'link'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'default-colors',
              'link'
            ]
          },
          'link--hover': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesDefaultColorsLinkHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'default-colors',
              state: 'link--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'default-colors',
              'link--hover'
            ]
          },
          'link-border--hover': {
            value: {
              value: '#fdd100',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#fdd100',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesDefaultColorsLinkBorderHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'default-colors',
              state: 'link-border--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'default-colors',
              'link-border--hover'
            ]
          },
          'icon-color': {
            value: {
              value: '#000000',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#000000',
                type: 'color'
              },
              name: 'ColorsPrimaryBlack',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black'
              },
              path: ['colors', 'primary', 'black']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesDefaultColorsIconColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'default-colors',
              state: 'icon-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'default-colors',
              'icon-color'
            ]
          },
          'icon-color--hover': {
            value: {
              value: '#fdd100',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#fdd100',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesDefaultColorsIconColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'default-colors',
              state: 'icon-color--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'default-colors',
              'icon-color--hover'
            ]
          }
        },
        'overlay-nav': {
          bg: {
            value: {
              value: '#fdd100',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#fdd100',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesOverlayNavBg',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'overlay-nav',
              state: 'bg'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'overlay-nav',
              'bg'
            ]
          },
          color: {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesOverlayNavColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'overlay-nav',
              state: 'color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'overlay-nav',
              'color'
            ]
          },
          'link-color': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesOverlayNavLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'overlay-nav',
              state: 'link-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'overlay-nav',
              'link-color'
            ]
          },
          'link--hover': {
            value: {
              value: '#545945',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#545945',
                type: 'color'
              },
              name: 'ThemeColorsOuterverseSecondaryGreenDark',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'secondary',
                subitem: 'green-dark'
              },
              path: ['theme-colors', 'outerverse', 'secondary', 'green-dark']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.secondary.green-dark}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesOverlayNavLinkHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'overlay-nav',
              state: 'link--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'overlay-nav',
              'link--hover'
            ]
          }
        },
        'primary-nav': {
          bg: {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesPrimaryNavBg',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'bg'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'primary-nav',
              'bg'
            ]
          },
          'link-color': {
            value: {
              value: '#000000',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#000000',
                type: 'color'
              },
              name: 'ColorsPrimaryBlack',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black'
              },
              path: ['colors', 'primary', 'black']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesPrimaryNavLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'link-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'primary-nav',
              'link-color'
            ]
          },
          'link-border-color': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesPrimaryNavLinkBorderColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'link-border-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'primary-nav',
              'link-border-color'
            ]
          },
          'link-color--hover': {
            value: {
              value: '#EA2127',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#EA2127',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryRed',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'red'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'red']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.red}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesPrimaryNavLinkColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'link-color--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'primary-nav',
              'link-color--hover'
            ]
          },
          'link-border-color--hover': {
            value: {
              value: '#fdd100',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#fdd100',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesPrimaryNavLinkBorderColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'link-border-color--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'primary-nav',
              'link-border-color--hover'
            ]
          },
          'link-bg--hover': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesPrimaryNavLinkBgHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'link-bg--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'primary-nav',
              'link-bg--hover'
            ]
          },
          'link-color--active': {
            value: {
              value: '#EA2127',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#EA2127',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryRed',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'red'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'red']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.red}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesPrimaryNavLinkColorActive',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'link-color--active'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'primary-nav',
              'link-color--active'
            ]
          },
          'link-border-color--active': {
            value: {
              value: '#fdd100',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#fdd100',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesPrimaryNavLinkBorderColorActive',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'link-border-color--active'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'primary-nav',
              'link-border-color--active'
            ]
          },
          'link-bg--active': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesPrimaryNavLinkBgActive',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'link-bg--active'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'primary-nav',
              'link-bg--active'
            ]
          },
          'dropdown-bg': {
            value: {
              value: '#ffffff',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#ffffff',
                type: 'color'
              },
              name: 'ColorsPrimaryWhite',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'white'
              },
              path: ['colors', 'primary', 'white']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.white}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesPrimaryNavDropdownBg',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'dropdown-bg'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'primary-nav',
              'dropdown-bg'
            ]
          },
          'dropdown-link-color': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesPrimaryNavDropdownLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'dropdown-link-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'primary-nav',
              'dropdown-link-color'
            ]
          },
          'dropdown-link-border-color': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesPrimaryNavDropdownLinkBorderColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'dropdown-link-border-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'primary-nav',
              'dropdown-link-border-color'
            ]
          },
          'dropdown-link-color--hover': {
            value: {
              value: '#EA2127',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#EA2127',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryRed',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'red'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'red']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.red}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesPrimaryNavDropdownLinkColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'dropdown-link-color--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'primary-nav',
              'dropdown-link-color--hover'
            ]
          },
          'dropdown-link-border-color--hover': {
            value: {
              value: '#fdd100',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#fdd100',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesPrimaryNavDropdownLinkBorderColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'dropdown-link-border-color--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'primary-nav',
              'dropdown-link-border-color--hover'
            ]
          },
          'dropdown-link-bg--hover': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesPrimaryNavDropdownLinkBgHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'dropdown-link-bg--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'primary-nav',
              'dropdown-link-bg--hover'
            ]
          },
          'dropdown-link-color--active': {
            value: {
              value: '#EA2127',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#EA2127',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryRed',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'red'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'red']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.red}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesPrimaryNavDropdownLinkColorActive',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'dropdown-link-color--active'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'primary-nav',
              'dropdown-link-color--active'
            ]
          },
          'dropdown-link-border-color--active': {
            value: {
              value: '#fdd100',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#fdd100',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesPrimaryNavDropdownLinkBorderColorActive',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'dropdown-link-border-color--active'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'primary-nav',
              'dropdown-link-border-color--active'
            ]
          },
          'dropdown-link-bg--active': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesPrimaryNavDropdownLinkBgActive',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'primary-nav',
              state: 'dropdown-link-bg--active'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'primary-nav',
              'dropdown-link-bg--active'
            ]
          }
        },
        'secondary-nav': {
          bg: {
            value: {
              value: '#ededed',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#ededed',
                type: 'color'
              },
              name: 'ColorsNeutralsGreyLight',
              attributes: {
                category: 'colors',
                type: 'neutrals',
                item: 'grey-light'
              },
              path: ['colors', 'neutrals', 'grey-light']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.neutrals.grey-light}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesSecondaryNavBg',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'bg'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'secondary-nav',
              'bg'
            ]
          },
          'link-color': {
            value: {
              value: '#000000',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#000000',
                type: 'color'
              },
              name: 'ColorsPrimaryBlack',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black'
              },
              path: ['colors', 'primary', 'black']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesSecondaryNavLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'link-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'secondary-nav',
              'link-color'
            ]
          },
          'link-border-color': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesSecondaryNavLinkBorderColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'link-border-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'secondary-nav',
              'link-border-color'
            ]
          },
          'link-color--hover': {
            value: {
              value: '#EA2127',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#EA2127',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryRed',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'red'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'red']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.red}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesSecondaryNavLinkColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'link-color--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'secondary-nav',
              'link-color--hover'
            ]
          },
          'link-border-color--hover': {
            value: {
              value: '#fdd100',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#fdd100',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesSecondaryNavLinkBorderColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'link-border-color--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'secondary-nav',
              'link-border-color--hover'
            ]
          },
          'link-bg--hover': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesSecondaryNavLinkBgHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'link-bg--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'secondary-nav',
              'link-bg--hover'
            ]
          },
          'link-color--active': {
            value: {
              value: '#EA2127',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#EA2127',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryRed',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'red'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'red']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.red}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesSecondaryNavLinkColorActive',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'link-color--active'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'secondary-nav',
              'link-color--active'
            ]
          },
          'link-border-color--active': {
            value: {
              value: '#fdd100',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#fdd100',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesSecondaryNavLinkBorderColorActive',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'link-border-color--active'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'secondary-nav',
              'link-border-color--active'
            ]
          },
          'link-bg--active': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesSecondaryNavLinkBgActive',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'link-bg--active'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'secondary-nav',
              'link-bg--active'
            ]
          },
          'dropdown-bg': {
            value: {
              value: '#ffffff',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#ffffff',
                type: 'color'
              },
              name: 'ColorsPrimaryWhite',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'white'
              },
              path: ['colors', 'primary', 'white']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.white}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesSecondaryNavDropdownBg',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'dropdown-bg'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'secondary-nav',
              'dropdown-bg'
            ]
          },
          'dropdown-link-color': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesSecondaryNavDropdownLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'dropdown-link-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'secondary-nav',
              'dropdown-link-color'
            ]
          },
          'dropdown-link-border-color': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesSecondaryNavDropdownLinkBorderColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'dropdown-link-border-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'secondary-nav',
              'dropdown-link-border-color'
            ]
          },
          'dropdown-link-color--hover': {
            value: {
              value: '#EA2127',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#EA2127',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryRed',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'red'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'red']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.red}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesSecondaryNavDropdownLinkColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'dropdown-link-color--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'secondary-nav',
              'dropdown-link-color--hover'
            ]
          },
          'dropdown-link-border-color--hover': {
            value: {
              value: '#fdd100',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#fdd100',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesSecondaryNavDropdownLinkBorderColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'dropdown-link-border-color--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'secondary-nav',
              'dropdown-link-border-color--hover'
            ]
          },
          'dropdown-link-bg--hover': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesSecondaryNavDropdownLinkBgHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'dropdown-link-bg--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'secondary-nav',
              'dropdown-link-bg--hover'
            ]
          },
          'dropdown-link-color--active': {
            value: {
              value: '#EA2127',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#EA2127',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryRed',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'red'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'red']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.red}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesSecondaryNavDropdownLinkColorActive',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'dropdown-link-color--active'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'secondary-nav',
              'dropdown-link-color--active'
            ]
          },
          'dropdown-link-border-color--active': {
            value: {
              value: '#fdd100',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#fdd100',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesSecondaryNavDropdownLinkBorderColorActive',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'dropdown-link-border-color--active'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'secondary-nav',
              'dropdown-link-border-color--active'
            ]
          },
          'dropdown-link-bg--active': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesSecondaryNavDropdownLinkBgActive',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'secondary-nav',
              state: 'dropdown-link-bg--active'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'secondary-nav',
              'dropdown-link-bg--active'
            ]
          }
        },
        tags: {
          'link-color': {
            value: {
              value: '#7e8489',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#7e8489',
                type: 'color'
              },
              name: 'ColorsNeutralsGreyDarker',
              attributes: {
                category: 'colors',
                type: 'neutrals',
                item: 'grey-darker'
              },
              path: ['colors', 'neutrals', 'grey-darker']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.neutrals.grey-darker}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesTagsLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'tags',
              state: 'link-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'tags',
              'link-color'
            ]
          },
          'link-color--hover': {
            value: {
              value: '#000000',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#000000',
                type: 'color'
              },
              name: 'ColorsPrimaryBlack',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black'
              },
              path: ['colors', 'primary', 'black']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesTagsLinkColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'tags',
              state: 'link-color--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'tags',
              'link-color--hover'
            ]
          }
        },
        articles: {
          'headline-link-color': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesArticlesHeadlineLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'articles',
              state: 'headline-link-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'articles',
              'headline-link-color'
            ]
          },
          'kicker-link-color': {
            value: {
              value: '#7e8489',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#7e8489',
                type: 'color'
              },
              name: 'ColorsNeutralsGreyDarker',
              attributes: {
                category: 'colors',
                type: 'neutrals',
                item: 'grey-darker'
              },
              path: ['colors', 'neutrals', 'grey-darker']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.neutrals.grey-darker}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesArticlesKickerLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'articles',
              state: 'kicker-link-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'articles',
              'kicker-link-color'
            ]
          },
          'post-meta-link-color': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesArticlesPostMetaLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'articles',
              state: 'post-meta-link-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'articles',
              'post-meta-link-color'
            ]
          },
          'postmeta-datetime-color': {
            value: {
              value: '#7e8489',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#7e8489',
                type: 'color'
              },
              name: 'ColorsNeutralsGreyDarker',
              attributes: {
                category: 'colors',
                type: 'neutrals',
                item: 'grey-darker'
              },
              path: ['colors', 'neutrals', 'grey-darker']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.neutrals.grey-darker}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesArticlesPostmetaDatetimeColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'articles',
              state: 'postmeta-datetime-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'articles',
              'postmeta-datetime-color'
            ]
          },
          'deck-color': {
            value: {
              value: '#545945',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#545945',
                type: 'color'
              },
              name: 'ThemeColorsOuterverseSecondaryGreenDark',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'secondary',
                subitem: 'green-dark'
              },
              path: ['theme-colors', 'outerverse', 'secondary', 'green-dark']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.secondary.green-dark}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesArticlesDeckColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'articles',
              state: 'deck-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'articles',
              'deck-color'
            ]
          },
          'headline-link-color--hover': {
            value: {
              value: '#EA2127',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#EA2127',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryRed',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'red'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'red']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.red}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesArticlesHeadlineLinkColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'articles',
              state: 'headline-link-color--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'articles',
              'headline-link-color--hover'
            ]
          },
          'kicker-link-color--hover': {
            value: {
              value: '#EA2127',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#EA2127',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryRed',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'red'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'red']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.red}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesArticlesKickerLinkColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'articles',
              state: 'kicker-link-color--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'articles',
              'kicker-link-color--hover'
            ]
          },
          'postmeta-link-color--hover': {
            value: {
              value: '#EA2127',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#EA2127',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryRed',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'red'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'red']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.red}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesArticlesPostmetaLinkColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'articles',
              state: 'postmeta-link-color--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'articles',
              'postmeta-link-color--hover'
            ]
          }
        },
        'form-components': {
          'value-color': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesFormComponentsValueColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'form-components',
              state: 'value-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'form-components',
              'value-color'
            ]
          },
          'label-color': {
            value: {
              value: '#7e8489',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#7e8489',
                type: 'color'
              },
              name: 'ColorsNeutralsGreyDarker',
              attributes: {
                category: 'colors',
                type: 'neutrals',
                item: 'grey-darker'
              },
              path: ['colors', 'neutrals', 'grey-darker']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.neutrals.grey-darker}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesFormComponentsLabelColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'form-components',
              state: 'label-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'form-components',
              'label-color'
            ]
          },
          bg: {
            value: {
              value: '#ffffff',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#ffffff',
                type: 'color'
              },
              name: 'ColorsPrimaryWhite',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'white'
              },
              path: ['colors', 'primary', 'white']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.white}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesFormComponentsBg',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'form-components',
              state: 'bg'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'form-components',
              'bg'
            ]
          },
          'border-color': {
            value: {
              value: '#ededed',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#ededed',
                type: 'color'
              },
              name: 'ColorsNeutralsGreyLight',
              attributes: {
                category: 'colors',
                type: 'neutrals',
                item: 'grey-light'
              },
              path: ['colors', 'neutrals', 'grey-light']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.neutrals.grey-light}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesFormComponentsBorderColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'form-components',
              state: 'border-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'form-components',
              'border-color'
            ]
          },
          'label-color--focus': {
            value: {
              value: '#7e8489',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#7e8489',
                type: 'color'
              },
              name: 'ColorsNeutralsGreyDarker',
              attributes: {
                category: 'colors',
                type: 'neutrals',
                item: 'grey-darker'
              },
              path: ['colors', 'neutrals', 'grey-darker']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.neutrals.grey-darker}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesFormComponentsLabelColorFocus',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'form-components',
              state: 'label-color--focus'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'form-components',
              'label-color--focus'
            ]
          },
          'bg--focus': {
            value: {
              value: '#f5f5f5',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#f5f5f5',
                type: 'color'
              },
              name: 'ColorsNeutralsGreyPale',
              attributes: {
                category: 'colors',
                type: 'neutrals',
                item: 'grey-pale'
              },
              path: ['colors', 'neutrals', 'grey-pale']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.neutrals.grey-pale}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesFormComponentsBgFocus',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'form-components',
              state: 'bg--focus'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'form-components',
              'bg--focus'
            ]
          },
          'border-color--focus': {
            value: {
              value: '#b7babc',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#b7babc',
                type: 'color'
              },
              name: 'ColorsNeutralsGreyDark',
              attributes: {
                category: 'colors',
                type: 'neutrals',
                item: 'grey-dark'
              },
              path: ['colors', 'neutrals', 'grey-dark']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.neutrals.grey-dark}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesFormComponentsBorderColorFocus',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'form-components',
              state: 'border-color--focus'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'form-components',
              'border-color--focus'
            ]
          }
        },
        buttons: {
          'primary-button-bg': {
            value: {
              value: '#fdd100',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#fdd100',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryYellow',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'yellow'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'yellow']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.yellow}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesButtonsPrimaryButtonBg',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'buttons',
              state: 'primary-button-bg'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'buttons',
              'primary-button-bg'
            ]
          },
          'primary-button-color': {
            value: {
              value: '#000000',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#000000',
                type: 'color'
              },
              name: 'ThemeColorsOuterverseTertiaryBlack',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'tertiary',
                subitem: 'black'
              },
              path: ['theme-colors', 'outerverse', 'tertiary', 'black']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.tertiary.black}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesButtonsPrimaryButtonColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'buttons',
              state: 'primary-button-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'buttons',
              'primary-button-color'
            ]
          },
          'primary-button-border-color': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesButtonsPrimaryButtonBorderColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'buttons',
              state: 'primary-button-border-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'buttons',
              'primary-button-border-color'
            ]
          },
          'primary-button-bg--hover': {
            value: {
              value: '#000000',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#000000',
                type: 'color'
              },
              name: 'ThemeColorsOuterverseTertiaryBlack',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'tertiary',
                subitem: 'black'
              },
              path: ['theme-colors', 'outerverse', 'tertiary', 'black']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.tertiary.black}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesButtonsPrimaryButtonBgHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'buttons',
              state: 'primary-button-bg--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'buttons',
              'primary-button-bg--hover'
            ]
          },
          'primary-button-color--hover': {
            value: {
              value: '#FFFFFF',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#FFFFFF',
                type: 'color'
              },
              name: 'ThemeColorsOuterverseTertiaryWhite',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'tertiary',
                subitem: 'white'
              },
              path: ['theme-colors', 'outerverse', 'tertiary', 'white']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.tertiary.white}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesButtonsPrimaryButtonColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'buttons',
              state: 'primary-button-color--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'buttons',
              'primary-button-color--hover'
            ]
          },
          'primary-button-border-color--hover': {
            value: {
              value: 'rgba(0, 0, 0, 0)',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: 'rgba(0, 0, 0, 0)',
                type: 'color'
              },
              name: 'ColorsPrimaryNone',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'none'
              },
              path: ['colors', 'primary', 'none']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.none}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesButtonsPrimaryButtonBorderColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'buttons',
              state: 'primary-button-border-color--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'buttons',
              'primary-button-border-color--hover'
            ]
          },
          'secondary-button-bg': {
            value: {
              value: '#363535',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#363535',
                type: 'color'
              },
              name: 'ThemeColorsOuterverseTertiaryBlackSoft',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'tertiary',
                subitem: 'black-soft'
              },
              path: ['theme-colors', 'outerverse', 'tertiary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.tertiary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesButtonsSecondaryButtonBg',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'buttons',
              state: 'secondary-button-bg'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'buttons',
              'secondary-button-bg'
            ]
          },
          'secondary-button-color': {
            value: {
              value: '#FFFFFF',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#FFFFFF',
                type: 'color'
              },
              name: 'ThemeColorsOuterverseTertiaryWhite',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'tertiary',
                subitem: 'white'
              },
              path: ['theme-colors', 'outerverse', 'tertiary', 'white']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.tertiary.white}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesButtonsSecondaryButtonColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'buttons',
              state: 'secondary-button-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'buttons',
              'secondary-button-color'
            ]
          },
          'secondary-button-border-color': {
            value: {
              value: '#363535',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#363535',
                type: 'color'
              },
              name: 'ThemeColorsOuterverseTertiaryBlackSoft',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'tertiary',
                subitem: 'black-soft'
              },
              path: ['theme-colors', 'outerverse', 'tertiary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.tertiary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesButtonsSecondaryButtonBorderColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'buttons',
              state: 'secondary-button-border-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'buttons',
              'secondary-button-border-color'
            ]
          },
          'secondary-button-bg--hover': {
            value: {
              value: '#FFFFFF',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#FFFFFF',
                type: 'color'
              },
              name: 'ThemeColorsOuterverseTertiaryWhite',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'tertiary',
                subitem: 'white'
              },
              path: ['theme-colors', 'outerverse', 'tertiary', 'white']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.tertiary.white}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesButtonsSecondaryButtonBgHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'buttons',
              state: 'secondary-button-bg--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'buttons',
              'secondary-button-bg--hover'
            ]
          },
          'secondary-button-color--hover': {
            value: {
              value: '#363535',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#363535',
                type: 'color'
              },
              name: 'ThemeColorsOuterverseTertiaryBlackSoft',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'tertiary',
                subitem: 'black-soft'
              },
              path: ['theme-colors', 'outerverse', 'tertiary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.tertiary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesButtonsSecondaryButtonColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'buttons',
              state: 'secondary-button-color--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'buttons',
              'secondary-button-color--hover'
            ]
          },
          'secondary-button-border-color--hover': {
            value: {
              value: '#363535',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#363535',
                type: 'color'
              },
              name: 'ThemeColorsOuterverseTertiaryBlackSoft',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'tertiary',
                subitem: 'black-soft'
              },
              path: ['theme-colors', 'outerverse', 'tertiary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.tertiary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesButtonsSecondaryButtonBorderColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'buttons',
              state: 'secondary-button-border-color--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'buttons',
              'secondary-button-border-color--hover'
            ]
          }
        },
        topics: {
          'icon-color': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesTopicsIconColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'topics',
              state: 'icon-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'topics',
              'icon-color'
            ]
          },
          'link-color': {
            value: {
              value: '#333333',
              type: 'color',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '#333333',
                type: 'color'
              },
              name: 'ColorsPrimaryBlackSoft',
              attributes: {
                category: 'colors',
                type: 'primary',
                item: 'black-soft'
              },
              path: ['colors', 'primary', 'black-soft']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{colors.primary.black-soft}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesTopicsLinkColor',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'topics',
              state: 'link-color'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'topics',
              'link-color'
            ]
          },
          'link-color--hover': {
            value: {
              value: '#EA2127',
              type: 'color',
              filePath: 'tokens.json',
              isSource: true,
              original: {
                value: '#EA2127',
                type: 'color'
              },
              name: 'ThemeColorsOuterversePrimaryRed',
              attributes: {
                category: 'theme-colors',
                type: 'outerverse',
                item: 'primary',
                subitem: 'red'
              },
              path: ['theme-colors', 'outerverse', 'primary', 'red']
            },
            type: 'color',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: '{theme-colors.outerverse.primary.red}',
              type: 'color'
            },
            name: 'ThemeColorsOuterverseVariablesTopicsLinkColorHover',
            attributes: {
              category: 'theme-colors',
              type: 'outerverse',
              item: 'variables',
              subitem: 'topics',
              state: 'link-color--hover'
            },
            path: [
              'theme-colors',
              'outerverse',
              'variables',
              'topics',
              'link-color--hover'
            ]
          }
        }
      }
    }
  },
  'theme-fontFamilies': {
    outerverse: {
      fonts: {
        'font-1': {
          value: 'WindsorConDExtBol',
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: 'WindsorConDExtBol',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOuterverseFontsFont1',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outerverse',
            item: 'fonts',
            subitem: 'font-1'
          },
          path: ['theme-fontFamilies', 'outerverse', 'fonts', 'font-1']
        },
        'font-2': {
          value: 'Inter',
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: 'Inter',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOuterverseFontsFont2',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outerverse',
            item: 'fonts',
            subitem: 'font-2'
          },
          path: ['theme-fontFamilies', 'outerverse', 'fonts', 'font-2']
        },
        'font-3': {
          value: 'WindsorEloD',
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: 'WindsorEloD',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOuterverseFontsFont3',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outerverse',
            item: 'fonts',
            subitem: 'font-3'
          },
          path: ['theme-fontFamilies', 'outerverse', 'fonts', 'font-3']
        },
        'font-4': {
          value: 'WindsorDUltHea',
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: 'WindsorDUltHea',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOuterverseFontsFont4',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outerverse',
            item: 'fonts',
            subitem: 'font-4'
          },
          path: ['theme-fontFamilies', 'outerverse', 'fonts', 'font-4']
        }
      },
      variables: {
        'headline--font': {
          value: {
            value: 'WindsorConDExtBol',
            type: 'fontFamilies',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: 'WindsorConDExtBol',
              type: 'fontFamilies'
            },
            name: 'ThemeFontFamiliesOuterverseFontsFont1',
            attributes: {
              category: 'theme-fontFamilies',
              type: 'outerverse',
              item: 'fonts',
              subitem: 'font-1'
            },
            path: ['theme-fontFamilies', 'outerverse', 'fonts', 'font-1']
          },
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{theme-fontFamilies.outerverse.fonts.font-1}',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOuterverseVariablesHeadlineFont',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outerverse',
            item: 'variables',
            subitem: 'headline--font'
          },
          path: [
            'theme-fontFamilies',
            'outerverse',
            'variables',
            'headline--font'
          ]
        },
        'headline-xl--font': {
          value: {
            value: 'WindsorConDExtBol',
            type: 'fontFamilies',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: 'WindsorConDExtBol',
              type: 'fontFamilies'
            },
            name: 'ThemeFontFamiliesOuterverseFontsFont1',
            attributes: {
              category: 'theme-fontFamilies',
              type: 'outerverse',
              item: 'fonts',
              subitem: 'font-1'
            },
            path: ['theme-fontFamilies', 'outerverse', 'fonts', 'font-1']
          },
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{theme-fontFamilies.outerverse.fonts.font-1}',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOuterverseVariablesHeadlineXlFont',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outerverse',
            item: 'variables',
            subitem: 'headline-xl--font'
          },
          path: [
            'theme-fontFamilies',
            'outerverse',
            'variables',
            'headline-xl--font'
          ]
        },
        'headline-h4--font': {
          value: {
            value: 'WindsorDUltHea',
            type: 'fontFamilies',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: 'WindsorDUltHea',
              type: 'fontFamilies'
            },
            name: 'ThemeFontFamiliesOuterverseFontsFont4',
            attributes: {
              category: 'theme-fontFamilies',
              type: 'outerverse',
              item: 'fonts',
              subitem: 'font-4'
            },
            path: ['theme-fontFamilies', 'outerverse', 'fonts', 'font-4']
          },
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{theme-fontFamilies.outerverse.fonts.font-4}',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOuterverseVariablesHeadlineH4Font',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outerverse',
            item: 'variables',
            subitem: 'headline-h4--font'
          },
          path: [
            'theme-fontFamilies',
            'outerverse',
            'variables',
            'headline-h4--font'
          ]
        },
        'utility-text--font': {
          value: {
            value: 'Inter',
            type: 'fontFamilies',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: 'Inter',
              type: 'fontFamilies'
            },
            name: 'ThemeFontFamiliesOuterverseFontsFont2',
            attributes: {
              category: 'theme-fontFamilies',
              type: 'outerverse',
              item: 'fonts',
              subitem: 'font-2'
            },
            path: ['theme-fontFamilies', 'outerverse', 'fonts', 'font-2']
          },
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{theme-fontFamilies.outerverse.fonts.font-2}',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOuterverseVariablesUtilityTextFont',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outerverse',
            item: 'variables',
            subitem: 'utility-text--font'
          },
          path: [
            'theme-fontFamilies',
            'outerverse',
            'variables',
            'utility-text--font'
          ]
        },
        'utility-text--uppercase-xl--font': {
          value: {
            value: 'Inter',
            type: 'fontFamilies',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: 'Inter',
              type: 'fontFamilies'
            },
            name: 'ThemeFontFamiliesOuterverseFontsFont2',
            attributes: {
              category: 'theme-fontFamilies',
              type: 'outerverse',
              item: 'fonts',
              subitem: 'font-2'
            },
            path: ['theme-fontFamilies', 'outerverse', 'fonts', 'font-2']
          },
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{theme-fontFamilies.outerverse.fonts.font-2}',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOuterverseVariablesUtilityTextUppercaseXlFont',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outerverse',
            item: 'variables',
            subitem: 'utility-text--uppercase-xl--font'
          },
          path: [
            'theme-fontFamilies',
            'outerverse',
            'variables',
            'utility-text--uppercase-xl--font'
          ]
        },
        'paragraph-copy--font': {
          value: {
            value: 'Inter',
            type: 'fontFamilies',
            filePath: 'tokens.json',
            isSource: true,
            original: {
              value: 'Inter',
              type: 'fontFamilies'
            },
            name: 'ThemeFontFamiliesOuterverseFontsFont2',
            attributes: {
              category: 'theme-fontFamilies',
              type: 'outerverse',
              item: 'fonts',
              subitem: 'font-2'
            },
            path: ['theme-fontFamilies', 'outerverse', 'fonts', 'font-2']
          },
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{theme-fontFamilies.outerverse.fonts.font-2}',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOuterverseVariablesParagraphCopyFont',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outerverse',
            item: 'variables',
            subitem: 'paragraph-copy--font'
          },
          path: [
            'theme-fontFamilies',
            'outerverse',
            'variables',
            'paragraph-copy--font'
          ]
        },
        'article-copy--font': {
          value: {
            value: 'ff-real-headline-pro',
            type: 'fontFamilies',
            filePath: 'network.json',
            isSource: true,
            original: {
              value: 'ff-real-headline-pro',
              type: 'fontFamilies'
            },
            name: 'FontFamiliesFontsFont2',
            attributes: {
              category: 'fontFamilies',
              type: 'fonts',
              item: 'font-2'
            },
            path: ['fontFamilies', 'fonts', 'font-2']
          },
          type: 'fontFamilies',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{fontFamilies.fonts.font-2}',
            type: 'fontFamilies'
          },
          name: 'ThemeFontFamiliesOuterverseVariablesArticleCopyFont',
          attributes: {
            category: 'theme-fontFamilies',
            type: 'outerverse',
            item: 'variables',
            subitem: 'article-copy--font'
          },
          path: [
            'theme-fontFamilies',
            'outerverse',
            'variables',
            'article-copy--font'
          ]
        }
      }
    }
  },
  'theme-fontWeights': {
    outerverse: {
      variables: {
        'headline--font-weight': {
          value: {
            value: '400',
            type: 'fontWeights',
            filePath: 'network.json',
            isSource: true,
            original: {
              value: '400',
              type: 'fontWeights'
            },
            name: 'FontWeightsWeights400',
            attributes: {
              category: 'fontWeights',
              type: 'weights',
              item: '400'
            },
            path: ['fontWeights', 'weights', '400']
          },
          type: 'fontWeights',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{fontWeights.weights.400}',
            type: 'fontWeights'
          },
          name: 'ThemeFontWeightsOuterverseVariablesHeadlineFontWeight',
          attributes: {
            category: 'theme-fontWeights',
            type: 'outerverse',
            item: 'variables',
            subitem: 'headline--font-weight'
          },
          path: [
            'theme-fontWeights',
            'outerverse',
            'variables',
            'headline--font-weight'
          ]
        },
        'headline-xl--font-weight': {
          value: {
            value: '400',
            type: 'fontWeights',
            filePath: 'network.json',
            isSource: true,
            original: {
              value: '400',
              type: 'fontWeights'
            },
            name: 'FontWeightsWeights400',
            attributes: {
              category: 'fontWeights',
              type: 'weights',
              item: '400'
            },
            path: ['fontWeights', 'weights', '400']
          },
          type: 'fontWeights',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{fontWeights.weights.400}',
            type: 'fontWeights'
          },
          name: 'ThemeFontWeightsOuterverseVariablesHeadlineXlFontWeight',
          attributes: {
            category: 'theme-fontWeights',
            type: 'outerverse',
            item: 'variables',
            subitem: 'headline-xl--font-weight'
          },
          path: [
            'theme-fontWeights',
            'outerverse',
            'variables',
            'headline-xl--font-weight'
          ]
        },
        'utility-text--font-weight': {
          value: {
            value: '400',
            type: 'fontWeights',
            filePath: 'network.json',
            isSource: true,
            original: {
              value: '400',
              type: 'fontWeights'
            },
            name: 'FontWeightsWeights400',
            attributes: {
              category: 'fontWeights',
              type: 'weights',
              item: '400'
            },
            path: ['fontWeights', 'weights', '400']
          },
          type: 'fontWeights',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{fontWeights.weights.400}',
            type: 'fontWeights'
          },
          name: 'ThemeFontWeightsOuterverseVariablesUtilityTextFontWeight',
          attributes: {
            category: 'theme-fontWeights',
            type: 'outerverse',
            item: 'variables',
            subitem: 'utility-text--font-weight'
          },
          path: [
            'theme-fontWeights',
            'outerverse',
            'variables',
            'utility-text--font-weight'
          ]
        },
        'utility-text--uppercase--font-weight': {
          value: {
            value: '400',
            type: 'fontWeights',
            filePath: 'network.json',
            isSource: true,
            original: {
              value: '400',
              type: 'fontWeights'
            },
            name: 'FontWeightsWeights400',
            attributes: {
              category: 'fontWeights',
              type: 'weights',
              item: '400'
            },
            path: ['fontWeights', 'weights', '400']
          },
          type: 'fontWeights',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{fontWeights.weights.400}',
            type: 'fontWeights'
          },
          name: 'ThemeFontWeightsOuterverseVariablesUtilityTextUppercaseFontWeight',
          attributes: {
            category: 'theme-fontWeights',
            type: 'outerverse',
            item: 'variables',
            subitem: 'utility-text--uppercase--font-weight'
          },
          path: [
            'theme-fontWeights',
            'outerverse',
            'variables',
            'utility-text--uppercase--font-weight'
          ]
        },
        'utility-text--uppercase-xl--font-weight': {
          value: {
            value: '700',
            type: 'fontWeights',
            filePath: 'network.json',
            isSource: true,
            original: {
              value: '700',
              type: 'fontWeights'
            },
            name: 'FontWeightsWeights700',
            attributes: {
              category: 'fontWeights',
              type: 'weights',
              item: '700'
            },
            path: ['fontWeights', 'weights', '700']
          },
          type: 'fontWeights',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{fontWeights.weights.700}',
            type: 'fontWeights'
          },
          name: 'ThemeFontWeightsOuterverseVariablesUtilityTextUppercaseXlFontWeight',
          attributes: {
            category: 'theme-fontWeights',
            type: 'outerverse',
            item: 'variables',
            subitem: 'utility-text--uppercase-xl--font-weight'
          },
          path: [
            'theme-fontWeights',
            'outerverse',
            'variables',
            'utility-text--uppercase-xl--font-weight'
          ]
        },
        'paragraph-copy--font-weight': {
          value: {
            value: '400',
            type: 'fontWeights',
            filePath: 'network.json',
            isSource: true,
            original: {
              value: '400',
              type: 'fontWeights'
            },
            name: 'FontWeightsWeights400',
            attributes: {
              category: 'fontWeights',
              type: 'weights',
              item: '400'
            },
            path: ['fontWeights', 'weights', '400']
          },
          type: 'fontWeights',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{fontWeights.weights.400}',
            type: 'fontWeights'
          },
          name: 'ThemeFontWeightsOuterverseVariablesParagraphCopyFontWeight',
          attributes: {
            category: 'theme-fontWeights',
            type: 'outerverse',
            item: 'variables',
            subitem: 'paragraph-copy--font-weight'
          },
          path: [
            'theme-fontWeights',
            'outerverse',
            'variables',
            'paragraph-copy--font-weight'
          ]
        },
        'article-copy--font-weight': {
          value: {
            value: '400',
            type: 'fontWeights',
            filePath: 'network.json',
            isSource: true,
            original: {
              value: '400',
              type: 'fontWeights'
            },
            name: 'FontWeightsWeights400',
            attributes: {
              category: 'fontWeights',
              type: 'weights',
              item: '400'
            },
            path: ['fontWeights', 'weights', '400']
          },
          type: 'fontWeights',
          filePath: 'tokens.json',
          isSource: true,
          original: {
            value: '{fontWeights.weights.400}',
            type: 'fontWeights'
          },
          name: 'ThemeFontWeightsOuterverseVariablesArticleCopyFontWeight',
          attributes: {
            category: 'theme-fontWeights',
            type: 'outerverse',
            item: 'variables',
            subitem: 'article-copy--font-weight'
          },
          path: [
            'theme-fontWeights',
            'outerverse',
            'variables',
            'article-copy--font-weight'
          ]
        }
      }
    }
  },
  colors: {
    primary: {
      black: {
        value: '#000000',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#000000',
          type: 'color'
        },
        name: 'ColorsPrimaryBlack',
        attributes: {
          category: 'colors',
          type: 'primary',
          item: 'black'
        },
        path: ['colors', 'primary', 'black']
      },
      'black-soft': {
        value: '#333333',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#333333',
          type: 'color'
        },
        name: 'ColorsPrimaryBlackSoft',
        attributes: {
          category: 'colors',
          type: 'primary',
          item: 'black-soft'
        },
        path: ['colors', 'primary', 'black-soft']
      },
      white: {
        value: '#ffffff',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#ffffff',
          type: 'color'
        },
        name: 'ColorsPrimaryWhite',
        attributes: {
          category: 'colors',
          type: 'primary',
          item: 'white'
        },
        path: ['colors', 'primary', 'white']
      },
      'outside-yellow': {
        value: '#fdd20a',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#fdd20a',
          type: 'color'
        },
        name: 'ColorsPrimaryOutsideYellow',
        attributes: {
          category: 'colors',
          type: 'primary',
          item: 'outside-yellow'
        },
        path: ['colors', 'primary', 'outside-yellow']
      },
      'outside-red': {
        value: '#ea2127',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#ea2127',
          type: 'color'
        },
        name: 'ColorsPrimaryOutsideRed',
        attributes: {
          category: 'colors',
          type: 'primary',
          item: 'outside-red'
        },
        path: ['colors', 'primary', 'outside-red']
      },
      none: {
        value: 'rgba(0, 0, 0, 0)',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: 'rgba(0, 0, 0, 0)',
          type: 'color'
        },
        name: 'ColorsPrimaryNone',
        attributes: {
          category: 'colors',
          type: 'primary',
          item: 'none'
        },
        path: ['colors', 'primary', 'none']
      }
    },
    secondary: {
      gold: {
        value: '#d2a940',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#d2a940',
          type: 'color'
        },
        name: 'ColorsSecondaryGold',
        attributes: {
          category: 'colors',
          type: 'secondary',
          item: 'gold'
        },
        path: ['colors', 'secondary', 'gold']
      },
      'gold-light': {
        value: '#ebd882',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#ebd882',
          type: 'color'
        },
        name: 'ColorsSecondaryGoldLight',
        attributes: {
          category: 'colors',
          type: 'secondary',
          item: 'gold-light'
        },
        path: ['colors', 'secondary', 'gold-light']
      },
      'gold-pale': {
        value: '#faf5de',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#faf5de',
          type: 'color'
        },
        name: 'ColorsSecondaryGoldPale',
        attributes: {
          category: 'colors',
          type: 'secondary',
          item: 'gold-pale'
        },
        path: ['colors', 'secondary', 'gold-pale']
      },
      brick: {
        value: '#951c00',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#951c00',
          type: 'color'
        },
        name: 'ColorsSecondaryBrick',
        attributes: {
          category: 'colors',
          type: 'secondary',
          item: 'brick'
        },
        path: ['colors', 'secondary', 'brick']
      },
      taupe: {
        value: '#c1bbaf',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#c1bbaf',
          type: 'color'
        },
        name: 'ColorsSecondaryTaupe',
        attributes: {
          category: 'colors',
          type: 'secondary',
          item: 'taupe'
        },
        path: ['colors', 'secondary', 'taupe']
      },
      'taupe-light': {
        value: '#e4dbca',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#e4dbca',
          type: 'color'
        },
        name: 'ColorsSecondaryTaupeLight',
        attributes: {
          category: 'colors',
          type: 'secondary',
          item: 'taupe-light'
        },
        path: ['colors', 'secondary', 'taupe-light']
      }
    },
    tertiary: {
      storm: {
        value: '#1792b8',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#1792b8',
          type: 'color'
        },
        name: 'ColorsTertiaryStorm',
        attributes: {
          category: 'colors',
          type: 'tertiary',
          item: 'storm'
        },
        path: ['colors', 'tertiary', 'storm']
      },
      'storm-light': {
        value: '#5bbfd3',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#5bbfd3',
          type: 'color'
        },
        name: 'ColorsTertiaryStormLight',
        attributes: {
          category: 'colors',
          type: 'tertiary',
          item: 'storm-light'
        },
        path: ['colors', 'tertiary', 'storm-light']
      },
      pine: {
        value: '#4bab77',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#4bab77',
          type: 'color'
        },
        name: 'ColorsTertiaryPine',
        attributes: {
          category: 'colors',
          type: 'tertiary',
          item: 'pine'
        },
        path: ['colors', 'tertiary', 'pine']
      }
    },
    neutrals: {
      'grey-darker': {
        value: '#7e8489',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#7e8489',
          type: 'color'
        },
        name: 'ColorsNeutralsGreyDarker',
        attributes: {
          category: 'colors',
          type: 'neutrals',
          item: 'grey-darker'
        },
        path: ['colors', 'neutrals', 'grey-darker']
      },
      'grey-dark': {
        value: '#b7babc',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#b7babc',
          type: 'color'
        },
        name: 'ColorsNeutralsGreyDark',
        attributes: {
          category: 'colors',
          type: 'neutrals',
          item: 'grey-dark'
        },
        path: ['colors', 'neutrals', 'grey-dark']
      },
      grey: {
        value: '#dbdada',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#dbdada',
          type: 'color'
        },
        name: 'ColorsNeutralsGrey',
        attributes: {
          category: 'colors',
          type: 'neutrals',
          item: 'grey'
        },
        path: ['colors', 'neutrals', 'grey']
      },
      'grey-light': {
        value: '#ededed',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#ededed',
          type: 'color'
        },
        name: 'ColorsNeutralsGreyLight',
        attributes: {
          category: 'colors',
          type: 'neutrals',
          item: 'grey-light'
        },
        path: ['colors', 'neutrals', 'grey-light']
      },
      'grey-pale': {
        value: '#f5f5f5',
        type: 'color',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '#f5f5f5',
          type: 'color'
        },
        name: 'ColorsNeutralsGreyPale',
        attributes: {
          category: 'colors',
          type: 'neutrals',
          item: 'grey-pale'
        },
        path: ['colors', 'neutrals', 'grey-pale']
      }
    }
  },
  fontFamilies: {
    fonts: {
      'font-1': {
        value: 'ff-real-headline-pro',
        type: 'fontFamilies',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: 'ff-real-headline-pro',
          type: 'fontFamilies'
        },
        name: 'FontFamiliesFontsFont1',
        attributes: {
          category: 'fontFamilies',
          type: 'fonts',
          item: 'font-1'
        },
        path: ['fontFamilies', 'fonts', 'font-1']
      },
      'font-2': {
        value: 'ff-real-headline-pro',
        type: 'fontFamilies',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: 'ff-real-headline-pro',
          type: 'fontFamilies'
        },
        name: 'FontFamiliesFontsFont2',
        attributes: {
          category: 'fontFamilies',
          type: 'fonts',
          item: 'font-2'
        },
        path: ['fontFamilies', 'fonts', 'font-2']
      },
      'font-3': {
        value: 'Georgia',
        type: 'fontFamilies',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: 'Georgia',
          type: 'fontFamilies'
        },
        name: 'FontFamiliesFontsFont3',
        attributes: {
          category: 'fontFamilies',
          type: 'fonts',
          item: 'font-3'
        },
        path: ['fontFamilies', 'fonts', 'font-3']
      }
    },
    uses: {
      'headline--font': {
        value: {
          value: 'ff-real-headline-pro',
          type: 'fontFamilies',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: 'ff-real-headline-pro',
            type: 'fontFamilies'
          },
          name: 'FontFamiliesFontsFont1',
          attributes: {
            category: 'fontFamilies',
            type: 'fonts',
            item: 'font-1'
          },
          path: ['fontFamilies', 'fonts', 'font-1']
        },
        type: 'fontFamilies',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontFamilies.fonts.font-1}',
          type: 'fontFamilies'
        },
        name: 'FontFamiliesUsesHeadlineFont',
        attributes: {
          category: 'fontFamilies',
          type: 'uses',
          item: 'headline--font'
        },
        path: ['fontFamilies', 'uses', 'headline--font']
      },
      'utility-text--font': {
        value: {
          value: 'ff-real-headline-pro',
          type: 'fontFamilies',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: 'ff-real-headline-pro',
            type: 'fontFamilies'
          },
          name: 'FontFamiliesFontsFont2',
          attributes: {
            category: 'fontFamilies',
            type: 'fonts',
            item: 'font-2'
          },
          path: ['fontFamilies', 'fonts', 'font-2']
        },
        type: 'fontFamilies',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontFamilies.fonts.font-2}',
          type: 'fontFamilies'
        },
        name: 'FontFamiliesUsesUtilityTextFont',
        attributes: {
          category: 'fontFamilies',
          type: 'uses',
          item: 'utility-text--font'
        },
        path: ['fontFamilies', 'uses', 'utility-text--font']
      },
      'paragraph-copy--font': {
        value: {
          value: 'ff-real-headline-pro',
          type: 'fontFamilies',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: 'ff-real-headline-pro',
            type: 'fontFamilies'
          },
          name: 'FontFamiliesFontsFont2',
          attributes: {
            category: 'fontFamilies',
            type: 'fonts',
            item: 'font-2'
          },
          path: ['fontFamilies', 'fonts', 'font-2']
        },
        type: 'fontFamilies',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontFamilies.fonts.font-2}',
          type: 'fontFamilies'
        },
        name: 'FontFamiliesUsesParagraphCopyFont',
        attributes: {
          category: 'fontFamilies',
          type: 'uses',
          item: 'paragraph-copy--font'
        },
        path: ['fontFamilies', 'uses', 'paragraph-copy--font']
      },
      'article-copy--font': {
        value: {
          value: 'Georgia',
          type: 'fontFamilies',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: 'Georgia',
            type: 'fontFamilies'
          },
          name: 'FontFamiliesFontsFont3',
          attributes: {
            category: 'fontFamilies',
            type: 'fonts',
            item: 'font-3'
          },
          path: ['fontFamilies', 'fonts', 'font-3']
        },
        type: 'fontFamilies',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontFamilies.fonts.font-3}',
          type: 'fontFamilies'
        },
        name: 'FontFamiliesUsesArticleCopyFont',
        attributes: {
          category: 'fontFamilies',
          type: 'uses',
          item: 'article-copy--font'
        },
        path: ['fontFamilies', 'uses', 'article-copy--font']
      }
    }
  },
  lineHeights: {
    shortest: {
      value: '130%',
      type: 'lineHeights',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '130%',
        type: 'lineHeights'
      },
      name: 'LineHeightsShortest',
      attributes: {
        category: 'lineHeights',
        type: 'shortest'
      },
      path: ['lineHeights', 'shortest']
    },
    short: {
      value: '135%',
      type: 'lineHeights',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '135%',
        type: 'lineHeights'
      },
      name: 'LineHeightsShort',
      attributes: {
        category: 'lineHeights',
        type: 'short'
      },
      path: ['lineHeights', 'short']
    },
    tall: {
      value: '140%',
      type: 'lineHeights',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '140%',
        type: 'lineHeights'
      },
      name: 'LineHeightsTall',
      attributes: {
        category: 'lineHeights',
        type: 'tall'
      },
      path: ['lineHeights', 'tall']
    },
    taller: {
      value: '150%',
      type: 'lineHeights',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '150%',
        type: 'lineHeights'
      },
      name: 'LineHeightsTaller',
      attributes: {
        category: 'lineHeights',
        type: 'taller'
      },
      path: ['lineHeights', 'taller']
    },
    tallest: {
      value: '160%',
      type: 'lineHeights',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '160%',
        type: 'lineHeights'
      },
      name: 'LineHeightsTallest',
      attributes: {
        category: 'lineHeights',
        type: 'tallest'
      },
      path: ['lineHeights', 'tallest']
    }
  },
  fontSizes: {
    12: {
      value: '12px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '12px',
        type: 'fontSizes'
      },
      name: 'FontSizes12',
      attributes: {
        category: 'fontSizes',
        type: '12'
      },
      path: ['fontSizes', '12']
    },
    13: {
      value: '13px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '13px',
        type: 'fontSizes'
      },
      name: 'FontSizes13',
      attributes: {
        category: 'fontSizes',
        type: '13'
      },
      path: ['fontSizes', '13']
    },
    14: {
      value: '14px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '14px',
        type: 'fontSizes'
      },
      name: 'FontSizes14',
      attributes: {
        category: 'fontSizes',
        type: '14'
      },
      path: ['fontSizes', '14']
    },
    15: {
      value: '15px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '15px',
        type: 'fontSizes'
      },
      name: 'FontSizes15',
      attributes: {
        category: 'fontSizes',
        type: '15'
      },
      path: ['fontSizes', '15']
    },
    16: {
      value: '16px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '16px',
        type: 'fontSizes'
      },
      name: 'FontSizes16',
      attributes: {
        category: 'fontSizes',
        type: '16'
      },
      path: ['fontSizes', '16']
    },
    17: {
      value: '17px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '17px',
        type: 'fontSizes'
      },
      name: 'FontSizes17',
      attributes: {
        category: 'fontSizes',
        type: '17'
      },
      path: ['fontSizes', '17']
    },
    18: {
      value: '18px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '18px',
        type: 'fontSizes'
      },
      name: 'FontSizes18',
      attributes: {
        category: 'fontSizes',
        type: '18'
      },
      path: ['fontSizes', '18']
    },
    20: {
      value: '20px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '20px',
        type: 'fontSizes'
      },
      name: 'FontSizes20',
      attributes: {
        category: 'fontSizes',
        type: '20'
      },
      path: ['fontSizes', '20']
    },
    22: {
      value: '22px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '22px',
        type: 'fontSizes'
      },
      name: 'FontSizes22',
      attributes: {
        category: 'fontSizes',
        type: '22'
      },
      path: ['fontSizes', '22']
    },
    24: {
      value: '24px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '24px',
        type: 'fontSizes'
      },
      name: 'FontSizes24',
      attributes: {
        category: 'fontSizes',
        type: '24'
      },
      path: ['fontSizes', '24']
    },
    26: {
      value: '26px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '26px',
        type: 'fontSizes'
      },
      name: 'FontSizes26',
      attributes: {
        category: 'fontSizes',
        type: '26'
      },
      path: ['fontSizes', '26']
    },
    30: {
      value: '30px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '30px',
        type: 'fontSizes'
      },
      name: 'FontSizes30',
      attributes: {
        category: 'fontSizes',
        type: '30'
      },
      path: ['fontSizes', '30']
    },
    32: {
      value: '32px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '32px',
        type: 'fontSizes'
      },
      name: 'FontSizes32',
      attributes: {
        category: 'fontSizes',
        type: '32'
      },
      path: ['fontSizes', '32']
    },
    36: {
      value: '36px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '36px',
        type: 'fontSizes'
      },
      name: 'FontSizes36',
      attributes: {
        category: 'fontSizes',
        type: '36'
      },
      path: ['fontSizes', '36']
    },
    40: {
      value: '40px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '40px',
        type: 'fontSizes'
      },
      name: 'FontSizes40',
      attributes: {
        category: 'fontSizes',
        type: '40'
      },
      path: ['fontSizes', '40']
    },
    42: {
      value: '42px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '42px',
        type: 'fontSizes'
      },
      name: 'FontSizes42',
      attributes: {
        category: 'fontSizes',
        type: '42'
      },
      path: ['fontSizes', '42']
    },
    50: {
      value: '50px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '50px',
        type: 'fontSizes'
      },
      name: 'FontSizes50',
      attributes: {
        category: 'fontSizes',
        type: '50'
      },
      path: ['fontSizes', '50']
    },
    60: {
      value: '60px',
      type: 'fontSizes',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '60px',
        type: 'fontSizes'
      },
      name: 'FontSizes60',
      attributes: {
        category: 'fontSizes',
        type: '60'
      },
      path: ['fontSizes', '60']
    }
  },
  fontWeights: {
    weights: {
      200: {
        value: '200',
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '200',
          type: 'fontWeights'
        },
        name: 'FontWeightsWeights200',
        attributes: {
          category: 'fontWeights',
          type: 'weights',
          item: '200'
        },
        path: ['fontWeights', 'weights', '200']
      },
      300: {
        value: '300',
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '300',
          type: 'fontWeights'
        },
        name: 'FontWeightsWeights300',
        attributes: {
          category: 'fontWeights',
          type: 'weights',
          item: '300'
        },
        path: ['fontWeights', 'weights', '300']
      },
      400: {
        value: '400',
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '400',
          type: 'fontWeights'
        },
        name: 'FontWeightsWeights400',
        attributes: {
          category: 'fontWeights',
          type: 'weights',
          item: '400'
        },
        path: ['fontWeights', 'weights', '400']
      },
      500: {
        value: '500',
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '500',
          type: 'fontWeights'
        },
        name: 'FontWeightsWeights500',
        attributes: {
          category: 'fontWeights',
          type: 'weights',
          item: '500'
        },
        path: ['fontWeights', 'weights', '500']
      },
      600: {
        value: '600',
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '600',
          type: 'fontWeights'
        },
        name: 'FontWeightsWeights600',
        attributes: {
          category: 'fontWeights',
          type: 'weights',
          item: '600'
        },
        path: ['fontWeights', 'weights', '600']
      },
      700: {
        value: '700',
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '700',
          type: 'fontWeights'
        },
        name: 'FontWeightsWeights700',
        attributes: {
          category: 'fontWeights',
          type: 'weights',
          item: '700'
        },
        path: ['fontWeights', 'weights', '700']
      },
      800: {
        value: '800',
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '800',
          type: 'fontWeights'
        },
        name: 'FontWeightsWeights800',
        attributes: {
          category: 'fontWeights',
          type: 'weights',
          item: '800'
        },
        path: ['fontWeights', 'weights', '800']
      },
      900: {
        value: '900',
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '900',
          type: 'fontWeights'
        },
        name: 'FontWeightsWeights900',
        attributes: {
          category: 'fontWeights',
          type: 'weights',
          item: '900'
        },
        path: ['fontWeights', 'weights', '900']
      }
    },
    uses: {
      'headline--font-weight': {
        value: {
          value: '500',
          type: 'fontWeights',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: '500',
            type: 'fontWeights'
          },
          name: 'FontWeightsWeights500',
          attributes: {
            category: 'fontWeights',
            type: 'weights',
            item: '500'
          },
          path: ['fontWeights', 'weights', '500']
        },
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontWeights.weights.500}',
          type: 'fontWeights'
        },
        name: 'FontWeightsUsesHeadlineFontWeight',
        attributes: {
          category: 'fontWeights',
          type: 'uses',
          item: 'headline--font-weight'
        },
        path: ['fontWeights', 'uses', 'headline--font-weight']
      },
      'headline-xl--font-weight': {
        value: {
          value: '600',
          type: 'fontWeights',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: '600',
            type: 'fontWeights'
          },
          name: 'FontWeightsWeights600',
          attributes: {
            category: 'fontWeights',
            type: 'weights',
            item: '600'
          },
          path: ['fontWeights', 'weights', '600']
        },
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontWeights.weights.600}',
          type: 'fontWeights'
        },
        name: 'FontWeightsUsesHeadlineXlFontWeight',
        attributes: {
          category: 'fontWeights',
          type: 'uses',
          item: 'headline-xl--font-weight'
        },
        path: ['fontWeights', 'uses', 'headline-xl--font-weight']
      },
      'utility-text--font-weight': {
        value: {
          value: '400',
          type: 'fontWeights',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: '400',
            type: 'fontWeights'
          },
          name: 'FontWeightsWeights400',
          attributes: {
            category: 'fontWeights',
            type: 'weights',
            item: '400'
          },
          path: ['fontWeights', 'weights', '400']
        },
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontWeights.weights.400}',
          type: 'fontWeights'
        },
        name: 'FontWeightsUsesUtilityTextFontWeight',
        attributes: {
          category: 'fontWeights',
          type: 'uses',
          item: 'utility-text--font-weight'
        },
        path: ['fontWeights', 'uses', 'utility-text--font-weight']
      },
      'utility-text--uppercase--font-weight': {
        value: {
          value: '700',
          type: 'fontWeights',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: '700',
            type: 'fontWeights'
          },
          name: 'FontWeightsWeights700',
          attributes: {
            category: 'fontWeights',
            type: 'weights',
            item: '700'
          },
          path: ['fontWeights', 'weights', '700']
        },
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontWeights.weights.700}',
          type: 'fontWeights'
        },
        name: 'FontWeightsUsesUtilityTextUppercaseFontWeight',
        attributes: {
          category: 'fontWeights',
          type: 'uses',
          item: 'utility-text--uppercase--font-weight'
        },
        path: ['fontWeights', 'uses', 'utility-text--uppercase--font-weight']
      },
      'utility-text--uppercase-xl--font-weight': {
        value: {
          value: '400',
          type: 'fontWeights',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: '400',
            type: 'fontWeights'
          },
          name: 'FontWeightsWeights400',
          attributes: {
            category: 'fontWeights',
            type: 'weights',
            item: '400'
          },
          path: ['fontWeights', 'weights', '400']
        },
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontWeights.weights.400}',
          type: 'fontWeights'
        },
        name: 'FontWeightsUsesUtilityTextUppercaseXlFontWeight',
        attributes: {
          category: 'fontWeights',
          type: 'uses',
          item: 'utility-text--uppercase-xl--font-weight'
        },
        path: ['fontWeights', 'uses', 'utility-text--uppercase-xl--font-weight']
      },
      'paragraph-copy--font-weight': {
        value: {
          value: '400',
          type: 'fontWeights',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: '400',
            type: 'fontWeights'
          },
          name: 'FontWeightsWeights400',
          attributes: {
            category: 'fontWeights',
            type: 'weights',
            item: '400'
          },
          path: ['fontWeights', 'weights', '400']
        },
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontWeights.weights.400}',
          type: 'fontWeights'
        },
        name: 'FontWeightsUsesParagraphCopyFontWeight',
        attributes: {
          category: 'fontWeights',
          type: 'uses',
          item: 'paragraph-copy--font-weight'
        },
        path: ['fontWeights', 'uses', 'paragraph-copy--font-weight']
      },
      'article-copy--font-weight': {
        value: {
          value: '400',
          type: 'fontWeights',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: '400',
            type: 'fontWeights'
          },
          name: 'FontWeightsWeights400',
          attributes: {
            category: 'fontWeights',
            type: 'weights',
            item: '400'
          },
          path: ['fontWeights', 'weights', '400']
        },
        type: 'fontWeights',
        filePath: 'network.json',
        isSource: true,
        original: {
          value: '{fontWeights.weights.400}',
          type: 'fontWeights'
        },
        name: 'FontWeightsUsesArticleCopyFontWeight',
        attributes: {
          category: 'fontWeights',
          type: 'uses',
          item: 'article-copy--font-weight'
        },
        path: ['fontWeights', 'uses', 'article-copy--font-weight']
      }
    }
  },
  borderRadius: {
    rounded: {
      value: '300px',
      type: 'borderRadius',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '300px',
        type: 'borderRadius'
      },
      name: 'BorderRadiusRounded',
      attributes: {
        category: 'borderRadius',
        type: 'rounded'
      },
      path: ['borderRadius', 'rounded']
    },
    default: {
      value: '4px',
      type: 'borderRadius',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '4px',
        type: 'borderRadius'
      },
      name: 'BorderRadiusDefault',
      attributes: {
        category: 'borderRadius',
        type: 'default'
      },
      path: ['borderRadius', 'default']
    },
    square: {
      value: '0px',
      type: 'borderRadius',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '0px',
        type: 'borderRadius'
      },
      name: 'BorderRadiusSquare',
      attributes: {
        category: 'borderRadius',
        type: 'square'
      },
      path: ['borderRadius', 'square']
    }
  },
  letterSpacing: {
    normal: {
      value: '0',
      type: 'letterSpacing',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '0',
        type: 'letterSpacing'
      },
      name: 'LetterSpacingNormal',
      attributes: {
        category: 'letterSpacing',
        type: 'normal'
      },
      path: ['letterSpacing', 'normal']
    },
    wide: {
      value: '.03em',
      type: 'letterSpacing',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '.03em',
        type: 'letterSpacing'
      },
      name: 'LetterSpacingWide',
      attributes: {
        category: 'letterSpacing',
        type: 'wide'
      },
      path: ['letterSpacing', 'wide']
    },
    'wide-x': {
      value: '.05em',
      type: 'letterSpacing',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '.05em',
        type: 'letterSpacing'
      },
      name: 'LetterSpacingWideX',
      attributes: {
        category: 'letterSpacing',
        type: 'wide-x'
      },
      path: ['letterSpacing', 'wide-x']
    },
    'wide-xx': {
      value: '.175em',
      type: 'letterSpacing',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '.175em',
        type: 'letterSpacing'
      },
      name: 'LetterSpacingWideXx',
      attributes: {
        category: 'letterSpacing',
        type: 'wide-xx'
      },
      path: ['letterSpacing', 'wide-xx']
    },
    'wide-xxx': {
      value: '.25em',
      type: 'letterSpacing',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '.25em',
        type: 'letterSpacing'
      },
      name: 'LetterSpacingWideXxx',
      attributes: {
        category: 'letterSpacing',
        type: 'wide-xxx'
      },
      path: ['letterSpacing', 'wide-xxx']
    }
  },
  typography: {
    mobile: {
      headlines: {
        h6: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '16px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '16px',
                type: 'fontSizes'
              },
              name: 'FontSizes16',
              attributes: {
                category: 'fontSizes',
                type: '16'
              },
              path: ['fontSizes', '16']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.16}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h6',
          attributes: {},
          path: ['typography', 'mobile', 'headlines', 'h6']
        },
        h5: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '18px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '18px',
                type: 'fontSizes'
              },
              name: 'FontSizes18',
              attributes: {
                category: 'fontSizes',
                type: '18'
              },
              path: ['fontSizes', '18']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.18}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h5',
          attributes: {},
          path: ['typography', 'mobile', 'headlines', 'h5']
        },
        h4: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '20px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '20px',
                type: 'fontSizes'
              },
              name: 'FontSizes20',
              attributes: {
                category: 'fontSizes',
                type: '20'
              },
              path: ['fontSizes', '20']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.20}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h4',
          attributes: {},
          path: ['typography', 'mobile', 'headlines', 'h4']
        },
        h3: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '22px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '22px',
                type: 'fontSizes'
              },
              name: 'FontSizes22',
              attributes: {
                category: 'fontSizes',
                type: '22'
              },
              path: ['fontSizes', '22']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.22}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h3',
          attributes: {},
          path: ['typography', 'mobile', 'headlines', 'h3']
        },
        h2: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '26px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '26px',
                type: 'fontSizes'
              },
              name: 'FontSizes26',
              attributes: {
                category: 'fontSizes',
                type: '26'
              },
              path: ['fontSizes', '26']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.26}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h2',
          attributes: {},
          path: ['typography', 'mobile', 'headlines', 'h2']
        },
        h1: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '30px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '30px',
                type: 'fontSizes'
              },
              name: 'FontSizes30',
              attributes: {
                category: 'fontSizes',
                type: '30'
              },
              path: ['fontSizes', '30']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.30}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h1',
          attributes: {},
          path: ['typography', 'mobile', 'headlines', 'h1']
        },
        xl: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '600',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '600',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights600',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '600'
                },
                path: ['fontWeights', 'weights', '600']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.600}',
                type: 'fontWeights'
              },
              name: 'headline-xl--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline-xl--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '40px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '40px',
                type: 'fontSizes'
              },
              name: 'FontSizes40',
              attributes: {
                category: 'fontSizes',
                type: '40'
              },
              path: ['fontSizes', '40']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline-xl--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.40}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'xl',
          attributes: {},
          path: ['typography', 'mobile', 'headlines', 'xl']
        }
      },
      'utility-text': {
        small: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'utility-text--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'utility-text--font-weight']
            },
            lineHeight: {
              value: '135%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '135%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShort',
              attributes: {
                category: 'lineHeights',
                type: 'short'
              },
              path: ['lineHeights', 'short']
            },
            fontSize: {
              value: '12px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '12px',
                type: 'fontSizes'
              },
              name: 'FontSizes12',
              attributes: {
                category: 'fontSizes',
                type: '12'
              },
              path: ['fontSizes', '12']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight: '{fontWeights.uses.utility-text--font-weight}',
              lineHeight: '{lineHeights.short}',
              fontSize: '{fontSizes.12}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'small',
          attributes: {},
          path: ['typography', 'mobile', 'utility-text', 'small']
        },
        large: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'utility-text--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'utility-text--font-weight']
            },
            lineHeight: {
              value: '135%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '135%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShort',
              attributes: {
                category: 'lineHeights',
                type: 'short'
              },
              path: ['lineHeights', 'short']
            },
            fontSize: {
              value: '15px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '15px',
                type: 'fontSizes'
              },
              name: 'FontSizes15',
              attributes: {
                category: 'fontSizes',
                type: '15'
              },
              path: ['fontSizes', '15']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight: '{fontWeights.uses.utility-text--font-weight}',
              lineHeight: '{lineHeights.short}',
              fontSize: '{fontSizes.15}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'large',
          attributes: {},
          path: ['typography', 'mobile', 'utility-text', 'large']
        },
        'uppercase--small': {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '700',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '700',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights700',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '700'
                },
                path: ['fontWeights', 'weights', '700']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.700}',
                type: 'fontWeights'
              },
              name: 'utility-text--uppercase--font-weight',
              attributes: {},
              path: [
                'fontWeights',
                'uses',
                'utility-text--uppercase--font-weight'
              ]
            },
            lineHeight: {
              value: '135%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '135%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShort',
              attributes: {
                category: 'lineHeights',
                type: 'short'
              },
              path: ['lineHeights', 'short']
            },
            fontSize: {
              value: '12px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '12px',
                type: 'fontSizes'
              },
              name: 'FontSizes12',
              attributes: {
                category: 'fontSizes',
                type: '12'
              },
              path: ['fontSizes', '12']
            },
            letterSpacing: {
              value: '.175em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.175em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWideXx',
              attributes: {
                category: 'letterSpacing',
                type: 'wide-xx'
              },
              path: ['letterSpacing', 'wide-xx']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight:
                '{fontWeights.uses.utility-text--uppercase--font-weight}',
              lineHeight: '{lineHeights.short}',
              fontSize: '{fontSizes.12}',
              letterSpacing: '{letterSpacing.wide-xx}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'uppercase--small',
          attributes: {},
          path: ['typography', 'mobile', 'utility-text', 'uppercase--small']
        },
        'uppercase--large': {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '700',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '700',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights700',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '700'
                },
                path: ['fontWeights', 'weights', '700']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.700}',
                type: 'fontWeights'
              },
              name: 'utility-text--uppercase--font-weight',
              attributes: {},
              path: [
                'fontWeights',
                'uses',
                'utility-text--uppercase--font-weight'
              ]
            },
            lineHeight: {
              value: '135%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '135%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShort',
              attributes: {
                category: 'lineHeights',
                type: 'short'
              },
              path: ['lineHeights', 'short']
            },
            fontSize: {
              value: '14px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '14px',
                type: 'fontSizes'
              },
              name: 'FontSizes14',
              attributes: {
                category: 'fontSizes',
                type: '14'
              },
              path: ['fontSizes', '14']
            },
            letterSpacing: {
              value: '.175em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.175em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWideXx',
              attributes: {
                category: 'letterSpacing',
                type: 'wide-xx'
              },
              path: ['letterSpacing', 'wide-xx']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight:
                '{fontWeights.uses.utility-text--uppercase--font-weight}',
              lineHeight: '{lineHeights.short}',
              fontSize: '{fontSizes.14}',
              letterSpacing: '{letterSpacing.wide-xx}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'uppercase--large',
          attributes: {},
          path: ['typography', 'mobile', 'utility-text', 'uppercase--large']
        },
        'uppercase--xl': {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'utility-text--uppercase-xl--font-weight',
              attributes: {},
              path: [
                'fontWeights',
                'uses',
                'utility-text--uppercase-xl--font-weight'
              ]
            },
            lineHeight: {
              value: '140%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '140%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTall',
              attributes: {
                category: 'lineHeights',
                type: 'tall'
              },
              path: ['lineHeights', 'tall']
            },
            fontSize: {
              value: '20px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '20px',
                type: 'fontSizes'
              },
              name: 'FontSizes20',
              attributes: {
                category: 'fontSizes',
                type: '20'
              },
              path: ['fontSizes', '20']
            },
            letterSpacing: {
              value: '.25em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.25em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWideXxx',
              attributes: {
                category: 'letterSpacing',
                type: 'wide-xxx'
              },
              path: ['letterSpacing', 'wide-xxx']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight:
                '{fontWeights.uses.utility-text--uppercase-xl--font-weight}',
              lineHeight: '{lineHeights.tall}',
              fontSize: '{fontSizes.20}',
              letterSpacing: '{letterSpacing.wide-xxx}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'uppercase--xl',
          attributes: {},
          path: ['typography', 'mobile', 'utility-text', 'uppercase--xl']
        }
      },
      'paragraph-copy': {
        small: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'paragraph-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'paragraph-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'paragraph-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'paragraph-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '13px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '13px',
                type: 'fontSizes'
              },
              name: 'FontSizes13',
              attributes: {
                category: 'fontSizes',
                type: '13'
              },
              path: ['fontSizes', '13']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.paragraph-copy--font}',
              fontWeight: '{fontWeights.uses.paragraph-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.13}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'small',
          attributes: {},
          path: ['typography', 'mobile', 'paragraph-copy', 'small']
        },
        standard: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'paragraph-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'paragraph-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'paragraph-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'paragraph-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '15px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '15px',
                type: 'fontSizes'
              },
              name: 'FontSizes15',
              attributes: {
                category: 'fontSizes',
                type: '15'
              },
              path: ['fontSizes', '15']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.paragraph-copy--font}',
              fontWeight: '{fontWeights.uses.paragraph-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.15}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'standard',
          attributes: {},
          path: ['typography', 'mobile', 'paragraph-copy', 'standard']
        }
      },
      'article-copy': {
        small: {
          value: {
            fontFamily: {
              value: {
                value: 'Georgia',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'Georgia',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont3',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-3'
                },
                path: ['fontFamilies', 'fonts', 'font-3']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-3}',
                type: 'fontFamilies'
              },
              name: 'article-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'article-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'article-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'article-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '15px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '15px',
                type: 'fontSizes'
              },
              name: 'FontSizes15',
              attributes: {
                category: 'fontSizes',
                type: '15'
              },
              path: ['fontSizes', '15']
            },
            letterSpacing: {
              value: '0',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingNormal',
              attributes: {
                category: 'letterSpacing',
                type: 'normal'
              },
              path: ['letterSpacing', 'normal']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.article-copy--font}',
              fontWeight: '{fontWeights.uses.article-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.15}',
              letterSpacing: '{letterSpacing.normal}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'small',
          attributes: {},
          path: ['typography', 'mobile', 'article-copy', 'small']
        },
        standard: {
          value: {
            fontFamily: {
              value: {
                value: 'Georgia',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'Georgia',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont3',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-3'
                },
                path: ['fontFamilies', 'fonts', 'font-3']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-3}',
                type: 'fontFamilies'
              },
              name: 'article-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'article-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'article-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'article-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '17px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '17px',
                type: 'fontSizes'
              },
              name: 'FontSizes17',
              attributes: {
                category: 'fontSizes',
                type: '17'
              },
              path: ['fontSizes', '17']
            },
            letterSpacing: {
              value: '0',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingNormal',
              attributes: {
                category: 'letterSpacing',
                type: 'normal'
              },
              path: ['letterSpacing', 'normal']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.article-copy--font}',
              fontWeight: '{fontWeights.uses.article-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.17}',
              letterSpacing: '{letterSpacing.normal}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'standard',
          attributes: {},
          path: ['typography', 'mobile', 'article-copy', 'standard']
        },
        'large-oblique': {
          value: {
            fontFamily: {
              value: {
                value: 'Georgia',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'Georgia',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont3',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-3'
                },
                path: ['fontFamilies', 'fonts', 'font-3']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-3}',
                type: 'fontFamilies'
              },
              name: 'article-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'article-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'article-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'article-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '18px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '18px',
                type: 'fontSizes'
              },
              name: 'FontSizes18',
              attributes: {
                category: 'fontSizes',
                type: '18'
              },
              path: ['fontSizes', '18']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.article-copy--font}',
              fontWeight: '{fontWeights.uses.article-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.18}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'large-oblique',
          attributes: {},
          path: ['typography', 'mobile', 'article-copy', 'large-oblique']
        }
      }
    },
    tablet: {
      headlines: {
        h6: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '16px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '16px',
                type: 'fontSizes'
              },
              name: 'FontSizes16',
              attributes: {
                category: 'fontSizes',
                type: '16'
              },
              path: ['fontSizes', '16']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.16}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h6',
          attributes: {},
          path: ['typography', 'tablet', 'headlines', 'h6']
        },
        h5: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '18px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '18px',
                type: 'fontSizes'
              },
              name: 'FontSizes18',
              attributes: {
                category: 'fontSizes',
                type: '18'
              },
              path: ['fontSizes', '18']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.18}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h5',
          attributes: {},
          path: ['typography', 'tablet', 'headlines', 'h5']
        },
        h4: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '22px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '22px',
                type: 'fontSizes'
              },
              name: 'FontSizes22',
              attributes: {
                category: 'fontSizes',
                type: '22'
              },
              path: ['fontSizes', '22']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.22}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h4',
          attributes: {},
          path: ['typography', 'tablet', 'headlines', 'h4']
        },
        h3: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '24px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '24px',
                type: 'fontSizes'
              },
              name: 'FontSizes24',
              attributes: {
                category: 'fontSizes',
                type: '24'
              },
              path: ['fontSizes', '24']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.24}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h3',
          attributes: {},
          path: ['typography', 'tablet', 'headlines', 'h3']
        },
        h2: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '30px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '30px',
                type: 'fontSizes'
              },
              name: 'FontSizes30',
              attributes: {
                category: 'fontSizes',
                type: '30'
              },
              path: ['fontSizes', '30']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.30}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h2',
          attributes: {},
          path: ['typography', 'tablet', 'headlines', 'h2']
        },
        h1: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '36px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '36px',
                type: 'fontSizes'
              },
              name: 'FontSizes36',
              attributes: {
                category: 'fontSizes',
                type: '36'
              },
              path: ['fontSizes', '36']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.36}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h1',
          attributes: {},
          path: ['typography', 'tablet', 'headlines', 'h1']
        },
        xl: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '600',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '600',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights600',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '600'
                },
                path: ['fontWeights', 'weights', '600']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.600}',
                type: 'fontWeights'
              },
              name: 'headline-xl--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline-xl--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '50px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '50px',
                type: 'fontSizes'
              },
              name: 'FontSizes50',
              attributes: {
                category: 'fontSizes',
                type: '50'
              },
              path: ['fontSizes', '50']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline-xl--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.50}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'xl',
          attributes: {},
          path: ['typography', 'tablet', 'headlines', 'xl']
        }
      }
    },
    desktop: {
      headlines: {
        h6: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '18px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '18px',
                type: 'fontSizes'
              },
              name: 'FontSizes18',
              attributes: {
                category: 'fontSizes',
                type: '18'
              },
              path: ['fontSizes', '18']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.18}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h6',
          attributes: {},
          path: ['typography', 'desktop', 'headlines', 'h6']
        },
        h5: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '20px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '20px',
                type: 'fontSizes'
              },
              name: 'FontSizes20',
              attributes: {
                category: 'fontSizes',
                type: '20'
              },
              path: ['fontSizes', '20']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.20}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h5',
          attributes: {},
          path: ['typography', 'desktop', 'headlines', 'h5']
        },
        h4: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '22px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '22px',
                type: 'fontSizes'
              },
              name: 'FontSizes22',
              attributes: {
                category: 'fontSizes',
                type: '22'
              },
              path: ['fontSizes', '22']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.22}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h4',
          attributes: {},
          path: ['typography', 'desktop', 'headlines', 'h4']
        },
        h3: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '26px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '26px',
                type: 'fontSizes'
              },
              name: 'FontSizes26',
              attributes: {
                category: 'fontSizes',
                type: '26'
              },
              path: ['fontSizes', '26']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.26}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h3',
          attributes: {},
          path: ['typography', 'desktop', 'headlines', 'h3']
        },
        h2: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '32px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '32px',
                type: 'fontSizes'
              },
              name: 'FontSizes32',
              attributes: {
                category: 'fontSizes',
                type: '32'
              },
              path: ['fontSizes', '32']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.32}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h2',
          attributes: {},
          path: ['typography', 'desktop', 'headlines', 'h2']
        },
        h1: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '500',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '500',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights500',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '500'
                },
                path: ['fontWeights', 'weights', '500']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.500}',
                type: 'fontWeights'
              },
              name: 'headline--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '42px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '42px',
                type: 'fontSizes'
              },
              name: 'FontSizes42',
              attributes: {
                category: 'fontSizes',
                type: '42'
              },
              path: ['fontSizes', '42']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.42}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'h1',
          attributes: {},
          path: ['typography', 'desktop', 'headlines', 'h1']
        },
        xl: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont1',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-1'
                },
                path: ['fontFamilies', 'fonts', 'font-1']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-1}',
                type: 'fontFamilies'
              },
              name: 'headline--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'headline--font']
            },
            fontWeight: {
              value: {
                value: '600',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '600',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights600',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '600'
                },
                path: ['fontWeights', 'weights', '600']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.600}',
                type: 'fontWeights'
              },
              name: 'headline-xl--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'headline-xl--font-weight']
            },
            lineHeight: {
              value: '130%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '130%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShortest',
              attributes: {
                category: 'lineHeights',
                type: 'shortest'
              },
              path: ['lineHeights', 'shortest']
            },
            fontSize: {
              value: '60px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '60px',
                type: 'fontSizes'
              },
              name: 'FontSizes60',
              attributes: {
                category: 'fontSizes',
                type: '60'
              },
              path: ['fontSizes', '60']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.headline--font}',
              fontWeight: '{fontWeights.uses.headline-xl--font-weight}',
              lineHeight: '{lineHeights.shortest}',
              fontSize: '{fontSizes.60}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'xl',
          attributes: {},
          path: ['typography', 'desktop', 'headlines', 'xl']
        }
      },
      'utility-text': {
        small: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'utility-text--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'utility-text--font-weight']
            },
            lineHeight: {
              value: '135%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '135%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShort',
              attributes: {
                category: 'lineHeights',
                type: 'short'
              },
              path: ['lineHeights', 'short']
            },
            fontSize: {
              value: '13px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '13px',
                type: 'fontSizes'
              },
              name: 'FontSizes13',
              attributes: {
                category: 'fontSizes',
                type: '13'
              },
              path: ['fontSizes', '13']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight: '{fontWeights.uses.utility-text--font-weight}',
              lineHeight: '{lineHeights.short}',
              fontSize: '{fontSizes.13}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'small',
          attributes: {},
          path: ['typography', 'desktop', 'utility-text', 'small']
        },
        large: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'utility-text--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'utility-text--font-weight']
            },
            lineHeight: {
              value: '135%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '135%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShort',
              attributes: {
                category: 'lineHeights',
                type: 'short'
              },
              path: ['lineHeights', 'short']
            },
            fontSize: {
              value: '16px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '16px',
                type: 'fontSizes'
              },
              name: 'FontSizes16',
              attributes: {
                category: 'fontSizes',
                type: '16'
              },
              path: ['fontSizes', '16']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight: '{fontWeights.uses.utility-text--font-weight}',
              lineHeight: '{lineHeights.short}',
              fontSize: '{fontSizes.16}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'large',
          attributes: {},
          path: ['typography', 'desktop', 'utility-text', 'large']
        },
        'uppercase--small': {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '700',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '700',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights700',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '700'
                },
                path: ['fontWeights', 'weights', '700']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.700}',
                type: 'fontWeights'
              },
              name: 'utility-text--uppercase--font-weight',
              attributes: {},
              path: [
                'fontWeights',
                'uses',
                'utility-text--uppercase--font-weight'
              ]
            },
            lineHeight: {
              value: '135%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '135%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShort',
              attributes: {
                category: 'lineHeights',
                type: 'short'
              },
              path: ['lineHeights', 'short']
            },
            fontSize: {
              value: '14px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '14px',
                type: 'fontSizes'
              },
              name: 'FontSizes14',
              attributes: {
                category: 'fontSizes',
                type: '14'
              },
              path: ['fontSizes', '14']
            },
            letterSpacing: {
              value: '.175em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.175em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWideXx',
              attributes: {
                category: 'letterSpacing',
                type: 'wide-xx'
              },
              path: ['letterSpacing', 'wide-xx']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight:
                '{fontWeights.uses.utility-text--uppercase--font-weight}',
              lineHeight: '{lineHeights.short}',
              fontSize: '{fontSizes.14}',
              letterSpacing: '{letterSpacing.wide-xx}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'uppercase--small',
          attributes: {},
          path: ['typography', 'desktop', 'utility-text', 'uppercase--small']
        },
        'uppercase--large': {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '700',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '700',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights700',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '700'
                },
                path: ['fontWeights', 'weights', '700']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.700}',
                type: 'fontWeights'
              },
              name: 'utility-text--uppercase--font-weight',
              attributes: {},
              path: [
                'fontWeights',
                'uses',
                'utility-text--uppercase--font-weight'
              ]
            },
            lineHeight: {
              value: '135%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '135%',
                type: 'lineHeights'
              },
              name: 'LineHeightsShort',
              attributes: {
                category: 'lineHeights',
                type: 'short'
              },
              path: ['lineHeights', 'short']
            },
            fontSize: {
              value: '16px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '16px',
                type: 'fontSizes'
              },
              name: 'FontSizes16',
              attributes: {
                category: 'fontSizes',
                type: '16'
              },
              path: ['fontSizes', '16']
            },
            letterSpacing: {
              value: '.175em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.175em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWideXx',
              attributes: {
                category: 'letterSpacing',
                type: 'wide-xx'
              },
              path: ['letterSpacing', 'wide-xx']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight:
                '{fontWeights.uses.utility-text--uppercase--font-weight}',
              lineHeight: '{lineHeights.short}',
              fontSize: '{fontSizes.16}',
              letterSpacing: '{letterSpacing.wide-xx}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'uppercase--large',
          attributes: {},
          path: ['typography', 'desktop', 'utility-text', 'uppercase--large']
        },
        'uppercase--xl': {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'utility-text--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'utility-text--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'utility-text--uppercase-xl--font-weight',
              attributes: {},
              path: [
                'fontWeights',
                'uses',
                'utility-text--uppercase-xl--font-weight'
              ]
            },
            lineHeight: {
              value: '140%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '140%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTall',
              attributes: {
                category: 'lineHeights',
                type: 'tall'
              },
              path: ['lineHeights', 'tall']
            },
            fontSize: {
              value: '26px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '26px',
                type: 'fontSizes'
              },
              name: 'FontSizes26',
              attributes: {
                category: 'fontSizes',
                type: '26'
              },
              path: ['fontSizes', '26']
            },
            letterSpacing: {
              value: '.25em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.25em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWideXxx',
              attributes: {
                category: 'letterSpacing',
                type: 'wide-xxx'
              },
              path: ['letterSpacing', 'wide-xxx']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.utility-text--font}',
              fontWeight:
                '{fontWeights.uses.utility-text--uppercase-xl--font-weight}',
              lineHeight: '{lineHeights.tall}',
              fontSize: '{fontSizes.26}',
              letterSpacing: '{letterSpacing.wide-xxx}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'uppercase--xl',
          attributes: {},
          path: ['typography', 'desktop', 'utility-text', 'uppercase--xl']
        }
      },
      'paragraph-styles': {
        small: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'paragraph-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'paragraph-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'paragraph-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'paragraph-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '14px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '14px',
                type: 'fontSizes'
              },
              name: 'FontSizes14',
              attributes: {
                category: 'fontSizes',
                type: '14'
              },
              path: ['fontSizes', '14']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.paragraph-copy--font}',
              fontWeight: '{fontWeights.uses.paragraph-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.14}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'small',
          attributes: {},
          path: ['typography', 'desktop', 'paragraph-styles', 'small']
        },
        standard: {
          value: {
            fontFamily: {
              value: {
                value: 'ff-real-headline-pro',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'ff-real-headline-pro',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont2',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-2'
                },
                path: ['fontFamilies', 'fonts', 'font-2']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-2}',
                type: 'fontFamilies'
              },
              name: 'paragraph-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'paragraph-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'paragraph-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'paragraph-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '16px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '16px',
                type: 'fontSizes'
              },
              name: 'FontSizes16',
              attributes: {
                category: 'fontSizes',
                type: '16'
              },
              path: ['fontSizes', '16']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.paragraph-copy--font}',
              fontWeight: '{fontWeights.uses.paragraph-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.16}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'standard',
          attributes: {},
          path: ['typography', 'desktop', 'paragraph-styles', 'standard']
        }
      },
      'article-copy': {
        small: {
          value: {
            fontFamily: {
              value: {
                value: 'Georgia',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'Georgia',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont3',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-3'
                },
                path: ['fontFamilies', 'fonts', 'font-3']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-3}',
                type: 'fontFamilies'
              },
              name: 'article-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'article-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'article-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'article-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '16px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '16px',
                type: 'fontSizes'
              },
              name: 'FontSizes16',
              attributes: {
                category: 'fontSizes',
                type: '16'
              },
              path: ['fontSizes', '16']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.article-copy--font}',
              fontWeight: '{fontWeights.uses.article-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.16}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'small',
          attributes: {},
          path: ['typography', 'desktop', 'article-copy', 'small']
        },
        standard: {
          value: {
            fontFamily: {
              value: {
                value: 'Georgia',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'Georgia',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont3',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-3'
                },
                path: ['fontFamilies', 'fonts', 'font-3']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-3}',
                type: 'fontFamilies'
              },
              name: 'article-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'article-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'article-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'article-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '18px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '18px',
                type: 'fontSizes'
              },
              name: 'FontSizes18',
              attributes: {
                category: 'fontSizes',
                type: '18'
              },
              path: ['fontSizes', '18']
            },
            letterSpacing: {
              value: '0',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingNormal',
              attributes: {
                category: 'letterSpacing',
                type: 'normal'
              },
              path: ['letterSpacing', 'normal']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.article-copy--font}',
              fontWeight: '{fontWeights.uses.article-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.18}',
              letterSpacing: '{letterSpacing.normal}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'standard',
          attributes: {},
          path: ['typography', 'desktop', 'article-copy', 'standard']
        },
        'large-oblique': {
          value: {
            fontFamily: {
              value: {
                value: 'Georgia',
                type: 'fontFamilies',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: 'Georgia',
                  type: 'fontFamilies'
                },
                name: 'FontFamiliesFontsFont3',
                attributes: {
                  category: 'fontFamilies',
                  type: 'fonts',
                  item: 'font-3'
                },
                path: ['fontFamilies', 'fonts', 'font-3']
              },
              type: 'fontFamilies',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontFamilies.fonts.font-3}',
                type: 'fontFamilies'
              },
              name: 'article-copy--font',
              attributes: {},
              path: ['fontFamilies', 'uses', 'article-copy--font']
            },
            fontWeight: {
              value: {
                value: '400',
                type: 'fontWeights',
                filePath: 'network.json',
                isSource: true,
                original: {
                  value: '400',
                  type: 'fontWeights'
                },
                name: 'FontWeightsWeights400',
                attributes: {
                  category: 'fontWeights',
                  type: 'weights',
                  item: '400'
                },
                path: ['fontWeights', 'weights', '400']
              },
              type: 'fontWeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '{fontWeights.weights.400}',
                type: 'fontWeights'
              },
              name: 'article-copy--font-weight',
              attributes: {},
              path: ['fontWeights', 'uses', 'article-copy--font-weight']
            },
            lineHeight: {
              value: '160%',
              type: 'lineHeights',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '160%',
                type: 'lineHeights'
              },
              name: 'LineHeightsTallest',
              attributes: {
                category: 'lineHeights',
                type: 'tallest'
              },
              path: ['lineHeights', 'tallest']
            },
            fontSize: {
              value: '20px',
              type: 'fontSizes',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '20px',
                type: 'fontSizes'
              },
              name: 'FontSizes20',
              attributes: {
                category: 'fontSizes',
                type: '20'
              },
              path: ['fontSizes', '20']
            },
            letterSpacing: {
              value: '.03em',
              type: 'letterSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '.03em',
                type: 'letterSpacing'
              },
              name: 'LetterSpacingWide',
              attributes: {
                category: 'letterSpacing',
                type: 'wide'
              },
              path: ['letterSpacing', 'wide']
            },
            paragraphSpacing: {
              value: '0',
              type: 'paragraphSpacing',
              filePath: 'network.json',
              isSource: true,
              original: {
                value: '0',
                type: 'paragraphSpacing'
              },
              name: 'ParagraphSpacingNormal',
              attributes: {
                category: 'paragraphSpacing',
                type: 'normal'
              },
              path: ['paragraphSpacing', 'normal']
            }
          },
          type: 'typography',
          filePath: 'network.json',
          isSource: true,
          original: {
            value: {
              fontFamily: '{fontFamilies.uses.article-copy--font}',
              fontWeight: '{fontWeights.uses.article-copy--font-weight}',
              lineHeight: '{lineHeights.tallest}',
              fontSize: '{fontSizes.20}',
              letterSpacing: '{letterSpacing.wide}',
              paragraphSpacing: '{paragraphSpacing.normal}'
            },
            type: 'typography'
          },
          name: 'large-oblique',
          attributes: {},
          path: ['typography', 'desktop', 'article-copy', 'large-oblique']
        }
      }
    }
  },
  paragraphSpacing: {
    normal: {
      value: '0',
      type: 'paragraphSpacing',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '0',
        type: 'paragraphSpacing'
      },
      name: 'ParagraphSpacingNormal',
      attributes: {
        category: 'paragraphSpacing',
        type: 'normal'
      },
      path: ['paragraphSpacing', 'normal']
    }
  },
  boxShadow: {
    none: {
      value: {
        x: '0',
        y: '0',
        spread: '0',
        color: 'rgba(0, 0, 0, 0,)',
        blur: '0'
      },
      type: 'boxShadow',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: {
          x: '0',
          y: '0',
          spread: '0',
          color: 'rgba(0, 0, 0, 0,)',
          blur: '0'
        },
        type: 'boxShadow'
      },
      name: 'BoxShadowNone',
      attributes: {
        category: 'boxShadow',
        type: 'none'
      },
      path: ['boxShadow', 'none']
    },
    default: {
      value: {
        x: '0',
        y: '1',
        spread: '0',
        color: 'rgba(0, 0, 0, .25)',
        blur: '3'
      },
      type: 'boxShadow',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: {
          x: '0',
          y: '1',
          spread: '0',
          color: 'rgba(0, 0, 0, .25)',
          blur: '3'
        },
        type: 'boxShadow'
      },
      name: 'BoxShadowDefault',
      attributes: {
        category: 'boxShadow',
        type: 'default'
      },
      path: ['boxShadow', 'default']
    },
    large: {
      value: {
        x: '0',
        y: '3',
        spread: '0',
        color: 'rgba(0, 0, 0, .2)',
        blur: '6'
      },
      type: 'boxShadow',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: {
          x: '0',
          y: '3',
          spread: '0',
          color: 'rgba(0, 0, 0, .2)',
          blur: '6'
        },
        type: 'boxShadow'
      },
      name: 'BoxShadowLarge',
      attributes: {
        category: 'boxShadow',
        type: 'large'
      },
      path: ['boxShadow', 'large']
    },
    'large-x': {
      value: {
        x: '0',
        y: '6',
        spread: '0',
        color: 'rgba(0, 0, 0,.2)',
        blur: '12'
      },
      type: 'boxShadow',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: {
          x: '0',
          y: '6',
          spread: '0',
          color: 'rgba(0, 0, 0,.2)',
          blur: '12'
        },
        type: 'boxShadow'
      },
      name: 'BoxShadowLargeX',
      attributes: {
        category: 'boxShadow',
        type: 'large-x'
      },
      path: ['boxShadow', 'large-x']
    }
  },
  borderWidth: {
    0: {
      value: '0px',
      type: 'borderWidth',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '0px',
        type: 'borderWidth'
      },
      name: 'BorderWidth0',
      attributes: {
        category: 'borderWidth',
        type: '0'
      },
      path: ['borderWidth', '0']
    },
    1: {
      value: '1px',
      type: 'borderWidth',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '1px',
        type: 'borderWidth'
      },
      name: 'BorderWidth1',
      attributes: {
        category: 'borderWidth',
        type: '1'
      },
      path: ['borderWidth', '1']
    },
    2: {
      value: '2px',
      type: 'borderWidth',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '2px',
        type: 'borderWidth'
      },
      name: 'BorderWidth2',
      attributes: {
        category: 'borderWidth',
        type: '2'
      },
      path: ['borderWidth', '2']
    },
    4: {
      value: '4px',
      type: 'borderWidth',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '4px',
        type: 'borderWidth'
      },
      name: 'BorderWidth4',
      attributes: {
        category: 'borderWidth',
        type: '4'
      },
      path: ['borderWidth', '4']
    },
    8: {
      value: '8px',
      type: 'borderWidth',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '8px',
        type: 'borderWidth'
      },
      name: 'BorderWidth8',
      attributes: {
        category: 'borderWidth',
        type: '8'
      },
      path: ['borderWidth', '8']
    }
  },
  backgroundPosition: {
    top: {
      value: 'top',
      type: 'backgroundPosition',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: 'top',
        type: 'backgroundPosition'
      },
      name: 'BackgroundPositionTop',
      attributes: {
        category: 'backgroundPosition',
        type: 'top'
      },
      path: ['backgroundPosition', 'top']
    },
    left: {
      value: 'left',
      type: 'backgroundPosition',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: 'left',
        type: 'backgroundPosition'
      },
      name: 'BackgroundPositionLeft',
      attributes: {
        category: 'backgroundPosition',
        type: 'left'
      },
      path: ['backgroundPosition', 'left']
    },
    bottom: {
      value: 'bottom',
      type: 'backgroundPosition',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: 'bottom',
        type: 'backgroundPosition'
      },
      name: 'BackgroundPositionBottom',
      attributes: {
        category: 'backgroundPosition',
        type: 'bottom'
      },
      path: ['backgroundPosition', 'bottom']
    },
    right: {
      value: 'right',
      type: 'backgroundPosition',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: 'right',
        type: 'backgroundPosition'
      },
      name: 'BackgroundPositionRight',
      attributes: {
        category: 'backgroundPosition',
        type: 'right'
      },
      path: ['backgroundPosition', 'right']
    },
    'left-top': {
      value: 'left top',
      type: 'backgroundPosition',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: 'left top',
        type: 'backgroundPosition'
      },
      name: 'BackgroundPositionLeftTop',
      attributes: {
        category: 'backgroundPosition',
        type: 'left-top'
      },
      path: ['backgroundPosition', 'left-top']
    },
    'left-bottom': {
      value: 'left bottom',
      type: 'backgroundPosition',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: 'left bottom',
        type: 'backgroundPosition'
      },
      name: 'BackgroundPositionLeftBottom',
      attributes: {
        category: 'backgroundPosition',
        type: 'left-bottom'
      },
      path: ['backgroundPosition', 'left-bottom']
    },
    'right-top': {
      value: 'right top',
      type: 'backgroundPosition',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: 'right top',
        type: 'backgroundPosition'
      },
      name: 'BackgroundPositionRightTop',
      attributes: {
        category: 'backgroundPosition',
        type: 'right-top'
      },
      path: ['backgroundPosition', 'right-top']
    },
    'right-bottom': {
      value: 'right bottom',
      type: 'backgroundPosition',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: 'right bottom',
        type: 'backgroundPosition'
      },
      name: 'BackgroundPositionRightBottom',
      attributes: {
        category: 'backgroundPosition',
        type: 'right-bottom'
      },
      path: ['backgroundPosition', 'right-bottom']
    }
  },
  breakpoints: {
    'narrow-xxx': {
      value: '480px',
      type: 'breakpoint',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '480px',
        type: 'breakpoint'
      },
      name: 'BreakpointsNarrowXxx',
      attributes: {
        category: 'breakpoints',
        type: 'narrow-xxx'
      },
      path: ['breakpoints', 'narrow-xxx']
    },
    'narrow-xx': {
      value: '640px',
      type: 'breakpoint',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '640px',
        type: 'breakpoint'
      },
      name: 'BreakpointsNarrowXx',
      attributes: {
        category: 'breakpoints',
        type: 'narrow-xx'
      },
      path: ['breakpoints', 'narrow-xx']
    },
    'narrow-x': {
      value: '767px',
      type: 'breakpoint',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '767px',
        type: 'breakpoint'
      },
      name: 'BreakpointsNarrowX',
      attributes: {
        category: 'breakpoints',
        type: 'narrow-x'
      },
      path: ['breakpoints', 'narrow-x']
    },
    narrow: {
      value: '1024px',
      type: 'breakpoint',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '1024px',
        type: 'breakpoint'
      },
      name: 'BreakpointsNarrow',
      attributes: {
        category: 'breakpoints',
        type: 'narrow'
      },
      path: ['breakpoints', 'narrow']
    },
    wide: {
      value: '1280px',
      type: 'breakpoint',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '1280px',
        type: 'breakpoint'
      },
      name: 'BreakpointsWide',
      attributes: {
        category: 'breakpoints',
        type: 'wide'
      },
      path: ['breakpoints', 'wide']
    },
    'wide-x': {
      value: '1440px',
      type: 'breakpoint',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '1440px',
        type: 'breakpoint'
      },
      name: 'BreakpointsWideX',
      attributes: {
        category: 'breakpoints',
        type: 'wide-x'
      },
      path: ['breakpoints', 'wide-x']
    },
    'wide-xx': {
      value: '1640',
      type: 'breakpoint',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '1640',
        type: 'breakpoint'
      },
      name: 'BreakpointsWideXx',
      attributes: {
        category: 'breakpoints',
        type: 'wide-xx'
      },
      path: ['breakpoints', 'wide-xx']
    },
    'wide-xxx': {
      value: '1750',
      type: 'breakpoint',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '1750',
        type: 'breakpoint'
      },
      name: 'BreakpointsWideXxx',
      attributes: {
        category: 'breakpoints',
        type: 'wide-xxx'
      },
      path: ['breakpoints', 'wide-xxx']
    }
  },
  space: {
    'padding-base': {
      value: '4px',
      type: 'spacing',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '4px',
        type: 'spacing'
      },
      name: 'SpacePaddingBase',
      attributes: {
        category: 'space',
        type: 'padding-base'
      },
      path: ['space', 'padding-base']
    },
    'margin-base': {
      value: '4px',
      type: 'spacing',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '4px',
        type: 'spacing'
      },
      name: 'SpaceMarginBase',
      attributes: {
        category: 'space',
        type: 'margin-base'
      },
      path: ['space', 'margin-base']
    }
  },
  grid: {
    'column-count': {
      value: '12',
      type: 'grid',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '12',
        type: 'grid'
      },
      name: 'GridColumnCount',
      attributes: {
        category: 'grid',
        type: 'column-count'
      },
      path: ['grid', 'column-count']
    },
    'column-gap-base': {
      value: '24px',
      type: 'grid',
      filePath: 'network.json',
      isSource: true,
      original: {
        value: '24px',
        type: 'grid'
      },
      name: 'GridColumnGapBase',
      attributes: {
        category: 'grid',
        type: 'column-gap-base'
      },
      path: ['grid', 'column-gap-base']
    }
  }
};
